'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var previousValue = 0;
var previousValue2DzoomValue = 28 * 0.1;
var previousValue2DpanValue = 0;
var pzIconURL = '//identicard.ca/cdn/shop/t/62/assets/';
//const pzIconURL = 'https://devcloud.productimize.com/promize-3d-cloud/';
//const pzIconURL = 'http://localhost/3d_projects/landyard/promize-3d-cloud/';


var PromizeHome = function (_React$Component) {
    _inherits(PromizeHome, _React$Component);

    function PromizeHome() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PromizeHome);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PromizeHome.__proto__ || Object.getPrototypeOf(PromizeHome)).call.apply(_ref, [this].concat(args))), _this), _this.repeatUploadedImageTop = { '3/4': 1000, '3/8': 1020, '5/8': 950, '1': 920 }, _this.state = {
            pzCustomizer: {},
            pzCanvas: {},
            pzCurrentView: 1,
            pzTotalViews: 1,
            pzActiveSection: 0,
            pzActiveTab: {},
            pzActiveOptionHover: {},
            pzUploadCanvasPopupContent: null,
            pzDefaultOptions: [],
            pzRules: {},
            pzHideTabs: [],
            pzHideAttributes: [],
            pzHideAttributeValues: [],
            pzApplyOptions: [],
            pzActiveOptions: {},
            pzActiveImages: {},
            pzCrossOrigin: 'Anonymous',

            pzApiUrl: 'https://lanyard.wristbands.com/node/',
            pzImgUrl: 'https://d2uom9by4anmt9.cloudfront.net/',
            pzIconsPath: pzIconURL,
            pzReplaceImg: './assets/images/',
            pzReplaceModelUrl: 'assets/images/',
            // pzReplaceImg: './assets/',
            // pzReplaceModelUrl: 'assets/',

            /*  
             pzApiUrl: https://devcloud.productimize.com/v3/promizenode/',
             pzIconsPath: pzIconURL,
             pzReplaceImg: '',
             pzReplaceModelUrl: '',
             */

            pzECommerceProductId: document.getElementById('web_product_id') ? document.getElementById('web_product_id').value : window.demoProductId,
            pzStoreHash: document.getElementById('shop_name') ? document.getElementById('shop_name').value : window.shop_name,
            pzEditId: window.editId,
            pzLoading: false,
            pzCanvasObject: {},
            fullScreen: 0,
            generalSettings: {},
            pzBasePrice: document.querySelector("meta[property='og:price:amount']") ? parseFloat(document.querySelector("meta[property='og:price:amount']").getAttribute("content").replace(",", "")) : document.querySelector("meta[property='product:price:amount']") ? parseFloat(document.querySelector("meta[property='product:price:amount']").getAttribute("content").replace(",", "")) : 0,
            pzProductPrice: document.querySelector("meta[property='og:price:amount']") ? parseFloat(document.querySelector("meta[property='og:price:amount']").getAttribute("content").replace(",", "")) : document.querySelector("meta[property='product:price:amount']") ? parseFloat(document.querySelector("meta[property='product:price:amount']").getAttribute("content").replace(",", "")) : 0,

            //pzProductPrice: 40,//(document.querySelector("meta[property='og:price:amount']")) ? parseFloat(document.querySelector("meta[property='og:price:amount']").getAttribute("content").replace(",", "")) : 0,
            //pzBasePrice: 40,
            pzQuantity: document.getElementById('min_qty') ? parseInt(document.getElementById('min_qty').value) : 100,
            pzMinimumQuantity: document.getElementById('min_qty') ? parseInt(document.getElementById('min_qty').value) : 100,
            pzQuantityMultiples: document.getElementById('qty_multiples') ? parseInt(document.getElementById('qty_multiples').value) : 100,
            pzBaseType: '',
            pzDesktopModels: {},
            pzMobileModels: {},
            promizeThreeDObj: null,
            promizeTwoDObj: null,
            pzSceneData: null,
            pzLoadDefaultOpitons: false,
            pzDownloadedModelUrl: {},
            pzInitControls: false,
            pzTextGroup: null,
            popup: false,
            applyType: "outside",
            pzPageLoader: true,
            pzPanSlider: 0,
            pzTextCount: 0,
            pzImageCount: 0,
            pzCopyObjectsKeys: [],
            pzCopyArraykeys: {},
            pzRepeatObjects: {},
            pzIsCopyRepeatObjects: false,
            pzCopyRepeatObjects: [],
            pzCopyOuterObjKeys: [],
            pzCopyInnerObjKeys: [],
            pzCopyOuterRepeatObjects: [],
            pzShowCopy: false,
            pzPopupBackgroundAttr: { tabId: 0, tabAttrId: 0 },
            pzPopupUploadImgErrorMsg: '',
            pzPopupUploadDPIMsg: '',
            pzPopupUploadImages: { 'outside': {}, 'inside': {} },
            pzPopupCanvasUploadImages: {},
            pzPopupViewType: 'outside',
            pzPopupRepeat: true,
            pzPopupViewBasedUploadType: { 'outside': 'repeat', 'inside': 'repeat' },
            pzPopupRepeatUploadImageKeys: [],
            pzPopupCopyToBoth: false,
            pzPopupPanSliderDefault: 0,
            pzPopupZoomSliderDefault: 28,
            pzPopupAppliedData: {},
            pzPopupFileUploaded: 0,
            pzPopupUploadImageProperties: {},
            pzDialogPopup: false,
            pzErrorDialogPopup: false,
            pzDyesubTextDefaultColor: '#000000',
            pzColorIconClicked: false,
            pzDownloadCartImageFontFamily: document.getElementById('download_cart_image_font') ? document.getElementById('download_cart_image_font').value : 'Roboto',
            pzModelType: document.getElementById('pz_model_type') ? document.getElementById('pz_model_type').value : 'closed',

            pzDomainIds: {
                751: {
                    'signatureText': 'Wristbands.com',
                },
                681: {
                    'signatureText': 'Wristbands.com',
                },
                806: {
                    'signatureText': 'Identicard.com',
                },
                815: {
                    'signatureText': 'Identicard.ca',
                }
            },
            pzModelCameraPositions: {
                'open': [],
                'closed': []
            },
            pzSizeProperties: {
                '3/4': {
                    'url': pzIconURL + '3_4.png',
                    'maxHeight': 42.8 * 2,
                    'maxHeightPopup': 15,
                    'maskHeight': 19
                },
                '3/8': {
                    'url': pzIconURL + '3_8.png',
                    'maxHeight': 21.5 * 2,
                    'maxHeightPopup': 6.2,
                    'maskHeight': 9.5
                },
                '5/8': {
                    'url': pzIconURL + '5_8.png',
                    'maxHeight': 34.8 * 2,
                    'maxHeightPopup': 11,
                    'maskHeight': 15.5
                },
                'one': {
                    'url': pzIconURL + '1.png',
                    'maxHeight': 57 * 2,
                    'maxHeightPopup': 19.8,
                    'maskHeight': 25
                }
            }
        }, _this.pzHistoryStack = {
            past: [],
            present: [],
            future: []
        }, _this.previousValue = 0, _this.getPoupContent = function () {}, _this.pzSetState = function (name, value) {
            _this.setState(_defineProperty({}, name, value));
        }, _this.pzSetBaseImage = function () {
            var _this$state = _this.state,
                pzCustomizer = _this$state.pzCustomizer,
                pzImgUrl = _this$state.pzImgUrl,
                pzCurrentView = _this$state.pzCurrentView,
                pzCanvas = _this$state.pzCanvas,
                pzCanvasObject = _this$state.pzCanvasObject;

            var setBaseImage = pzCustomizer.product.model_image;
            var model_image = JSON.parse(setBaseImage);
            var downloadingImage = null;

            if (model_image && model_image.length > 0) {
                downloadingImage = pzImgUrl + model_image[0].image_url;
                var modelObject = {
                    "src": downloadingImage,
                    "name": "baseimage",
                    "selectable": false,
                    "hasControls": false,
                    "hasBorders": false,
                    'crossOrigin': 'anonymous',
                    "layerno": -1,
                    type: "image"
                };
                Object.keys(pzCustomizer).length > 0 && model_image.map(function (modeview, view_index) {
                    var baseImage = pzImgUrl + modeview.image_url;
                    if (pzCanvasObject[modeview.id] == undefined) {
                        pzCanvasObject[modeview.id] = {};
                    }
                    pzCanvasObject[modeview.id]['baseImage'] = Object.assign({}, _extends({}, modelObject), { 'src': baseImage });
                    // if (pzCustomizer.product.overlay_details) {
                    //     console.log(modeview.id)
                    //     var pzOverlayDetails = JSON.parse(pzCustomizer.product.overlay_details);
                    //     pzCanvasObject[modeview.id]['OverlayImage'] = Object.assign({ ...pzOverlayDetails[modeview.id] }, { 'src': pzImgUrl + pzOverlayDetails[modeview.id].url, 'layerno': 2, "selectable": false, "hasControls": false, "hasBorders": false, 'crossOrigin': 'anonymous', "layerno": -1, "type": "image", 'name': 'OverlayImage' });
                    // }
                });
                //this.setState({ 'pzCurrentView': model_image[0].id, pzTotalViews: model_image.length, pzCanvasObject });
                _this.setState({ 'pzCurrentView': model_image[0].id, pzTotalViews: model_image.length, pzCanvasObject: pzCanvasObject }, function () {
                    _this.pzReloadCanvasObjects();
                });
            }
        }, _this.pzSetSelectedTab = function (tabId, tabData) {
            var _this$state2 = _this.state,
                pzActiveTab = _this$state2.pzActiveTab,
                pzActiveSection = _this$state2.pzActiveSection,
                pzCurrentView = _this$state2.pzCurrentView;

            var currView = tabData.default_view && tabData.default_view != pzCurrentView ? tabData.default_view : pzCurrentView;
            if (pzActiveTab[pzActiveSection] == tabId) {
                pzActiveTab[pzActiveSection] = '';
            } else {
                pzActiveTab[pzActiveSection] = tabId;
            }
            _this.setState({ pzActiveTab: pzActiveTab, pzCurrentView: currView }, function () {
                tabData.default_view && tabData.default_view != pzCurrentView && _this.pzReloadCanvasObjects();
            });
        }, _this.pzOperatorComparison = function (post, operator, value) {
            switch (operator) {
                case '>':
                    return post > value;
                case '<':
                    return post < value;
                case '>=':
                    return post >= value;
                case '<=':
                    return post <= value;
                case '==':
                    return post == value;
                case '!=':
                    return post != value;
                case '===':
                    return post === value;
                case '!==':
                    return post !== value;
                case '&&':
                    return post && value;
                case '||':
                    return post || value;
                case 'includes':
                    return post.includes(value);
                case '!includes':
                    return !post.includes(value);
            }
        }, _this.pzRuleValue = function (key) {
            switch (key) {
                case 'IS':
                    return 'includes';
                case 'IS NOT':
                    return '!includes';
                case 'INCLUDES':
                    return 'includes';
                case 'DOES NOT INCLUDES':
                    return '!includes';
                case 'IS LESSER THAN':
                    return '<';
                case 'IS GREATER THAN':
                    return '>';
            }
        }, _this.pzApplyRules = function () {
            var _this$state3 = _this.state,
                pzRules = _this$state3.pzRules,
                pzActiveOptions = _this$state3.pzActiveOptions,
                pzApplyOptions = _this$state3.pzApplyOptions,
                pzCanvas = _this$state3.pzCanvas,
                pzCanvasObject = _this$state3.pzCanvasObject,
                pzCurrentView = _this$state3.pzCurrentView;

            var pzHideTabs = [],
                pzHideAttributes = [],
                pzHideAttributeValues = [];
            var allSelectedOptions = [];
            Object.keys(pzActiveOptions).map(function (key, index) {
                pzActiveOptions[key] && allSelectedOptions.push(("" + pzActiveOptions[key][1]).toString());
            });
            // Hide the Show actions
            pzRules.length > 0 && pzRules.map(function (rule, rule_index) {
                rule.promize_actions.length > 0 && rule.promize_actions.map(function (action, action_index) {
                    var attribute_values = action.promize_tab_attribute_value_id ? action.promize_tab_attribute_value_id.split(',') : [];
                    var tab = action.promize_tab_id ? action.promize_tab_id : undefined;
                    var tab_attribute = action.promize_tab_attribute_id ? action.promize_tab_attribute_id : undefined;
                    var action_value = action.promize_setting.reference_name;
                    if (action_value == 'SHOW') {
                        attribute_values.length > 0 && attribute_values.map(function (val, index) {
                            pzHideAttributeValues.push(parseInt(val));
                        });
                        tab_attribute && attribute_values.length == 0 && pzHideAttributes.push(tab_attribute);
                        tab && tab_attribute == undefined && attribute_values.length == 0 && pzHideTabs.push(tab);
                    }
                });
            });
            //console.log("allSelectedOptions", allSelectedOptions)

            //Apply rules if conditions get staisfied
            pzRules.length > 0 && pzRules.map(function (rule, rule_index) {
                var rule_condition = rule.rule_condition_id == 1 ? '&&' : '||';
                var rule_value = rule.rule_value_id == 3 ? true : false;
                var checked_conditions = [];
                rule.promize_conditions.length > 0 && rule.promize_conditions.map(function (condition, condition_index) {
                    var attribute_values = condition.promize_tab_attribute_value_id ? condition.promize_tab_attribute_value_id.split(',') : [];
                    var tab = condition.promize_tab_id ? condition.promize_tab_id : undefined;
                    var tab_attribute = condition.promize_tab_attribute_id ? condition.promize_tab_attribute_id : undefined;
                    var condition_value = _this.pzRuleValue(condition.promize_setting.reference_name);
                    var checked_value = false;
                    if (attribute_values) {
                        var isValueSelected = allSelectedOptions.some(function (value) {
                            return attribute_values.includes(value);
                        });
                        checked_value = condition_value == 'includes' ? isValueSelected ? true : false : isValueSelected ? false : true;
                    } else if (tab_attribute) {
                        var selectedval = pzActiveOptions[tab_attribute];
                        checked_value = _this.pzOperatorComparison(attribute_values, condition_value, ("" + selectedval).toString());
                    }
                    checked_conditions.push(checked_value);
                });

                var applyAction = false;
                if (rule_condition == '&&' && rule_value) {
                    applyAction = checked_conditions.includes(false) ? false : true;
                } else if (rule_condition == '&&' && !rule_value) {
                    applyAction = checked_conditions.includes(true) ? true : false;
                } else if (rule_condition == '||' && rule_value) {
                    applyAction = checked_conditions.includes(true) ? true : false;
                } else if (rule_condition == '||' && !rule_value) {
                    applyAction = checked_conditions.includes(false) ? true : false;
                }
                //console.log("applyAction",applyAction )
                if (applyAction) {
                    rule.promize_actions.length > 0 && rule.promize_actions.map(function (action, action_index) {
                        var attribute_values = action.promize_tab_attribute_value_id ? action.promize_tab_attribute_value_id.split(',') : [];
                        var tab = action.promize_tab_id ? action.promize_tab_id : undefined;
                        var tab_attribute = action.promize_tab_attribute_id ? action.promize_tab_attribute_id : undefined;
                        var action_value = action.promize_setting.reference_name;
                        if (action_value == 'HIDE') {
                            if (attribute_values.length > 0) {
                                attribute_values.map(function (val, index) {
                                    pzHideAttributeValues.push(parseInt(val));
                                });
                            } else if (tab_attribute) {
                                pzHideAttributes.push(tab_attribute);
                            } else if (tab) {
                                pzHideTabs.push(tab);
                            }
                        } else if (action_value == 'APPLY') {
                            if (tab && tab_attribute && attribute_values.length > 0) {
                                pzActiveOptions[tab] == undefined && attribute_values.map(function (val, index) {
                                    pzApplyOptions.push(parseInt(val));
                                });
                                pzActiveOptions[tab] != undefined && pzActiveOptions[tab][0] != tab_attribute && attribute_values.map(function (val, index) {
                                    pzApplyOptions.push(parseInt(val));
                                });
                            }
                        } else if (action_value == 'SHOW') {
                            if (attribute_values.length > 0) {
                                var filteredTabAttributeValues = attribute_values.filter(function (obj) {
                                    return pzHideAttributeValues.indexOf(parseInt(obj)) == -1;
                                });
                                pzHideAttributeValues = filteredTabAttributeValues;
                            } else if (tab_attribute) {
                                var filteredTabAttributes = pzHideAttributes.filter(function (value) {
                                    return value != tab_attribute;
                                });
                                pzHideAttributes = filteredTabAttributes;
                            } else if (tab) {
                                var filteredTabs = pzHideTabs.filter(function (value) {
                                    return value != tab;
                                });
                                pzHideTabs = filteredTabs;
                            };
                        }
                    });
                }
            });
            //Remove from canvas
            pzHideTabs.length > 0 && pzHideTabs.map(function (tab_id) {
                var canvasObj = _this.pzCanvasObjectGetItemByFieldName('tabId', tab_id);
                if (canvasObj) {
                    console.log("canvasObj ", canvasObj);
                    if (canvasObj.uploadedImageKeys) {
                        _this.pzRemoveExistingImageFromCanvas(canvasObj.uploadedImageKeys, '');
                    }

                    delete pzCanvasObject[canvasObj.name];
                    delete pzActiveOptions[canvasObj.tabId];
                }

                /* let canvasObj = pzCanvas.getItemByField('tabId', tab_id);
                if (canvasObj) {
                    pzRemoveObjectFromCanvas(pzCanvas, canvasObj)
                    delete pzCanvasObject[pzCurrentView][canvasObj.name]
                    delete pzActiveOptions[canvasObj.tabId]
                } */
            });
            pzHideAttributes.length > 0 && pzHideAttributes.map(function (tabAttrId) {
                var canvasObj = _this.pzCanvasObjectGetItemByFieldName('tabAttrId', tabAttrId);
                if (canvasObj) {
                    console.log("canvasObj ", canvasObj);
                    if (canvasObj.uploadedImageKeys) {
                        _this.pzRemoveExistingImageFromCanvas(canvasObj.uploadedImageKeys, '');
                    }
                    delete pzCanvasObject[canvasObj.name];
                    delete pzActiveOptions[canvasObj.tabAttrId];
                }
                /* let canvasObj = pzCanvas.getItemByField('tabAttrId', tabAttrId);
                if (canvasObj) {
                    pzRemoveObjectFromCanvas(pzCanvas, canvasObj)
                    delete pzCanvasObject[pzCurrentView][canvasObj.name]
                    delete pzActiveOptions[canvasObj.tabAttrId]
                } */
            });
            pzHideAttributeValues.length > 0 && pzHideAttributeValues.map(function (tabAttrValueId) {
                var canvasObj = _this.pzCanvasObjectGetItemByFieldName('tabAttrValueId', tabAttrValueId);

                if (canvasObj) {
                    console.log("canvasObj ", canvasObj);
                    if (canvasObj.uploadedImageKeys) {
                        _this.pzRemoveExistingImageFromCanvas(canvasObj.uploadedImageKeys, '');
                    }
                    delete pzCanvasObject[canvasObj.name];
                    delete pzActiveOptions[canvasObj.tabAttrValueId];
                }

                /* let canvasObj = pzCanvas.getItemByField('tabAttrValueId', tabAttrValueId);
                if (canvasObj) {
                    pzRemoveObjectFromCanvas(pzCanvas, canvasObj)
                    delete pzCanvasObject[pzCurrentView][canvasObj.name]
                    delete pzActiveOptions[canvasObj.tabAttrValueId]
                } */
            });
            _this.setState({ pzHideTabs: pzHideTabs, pzHideAttributes: pzHideAttributes, pzHideAttributeValues: pzHideAttributeValues, pzApplyOptions: pzApplyOptions, pzActiveOptions: pzActiveOptions, pzCanvas: pzCanvas, pzCanvasObject: pzCanvasObject });
        }, _this.pzReloadCanvasObjects = function () {
            var pzCanvas = pzLoadCanvasObjects(_extends({}, _this.state));
            _this.setState({ pzCanvas: pzCanvas });
        }, _this.pzObjectProperty = function (pzObject) {
            var pzObjectId = pzObject.name.split('_');
            var pzCanvasObject = _this.state.pzCanvasObject;
            if (pzObjectId && pzObjectId[2] && pzObjectId[3]) {
                pzCanvasObject[_this.state.pzCurrentView][pzObject.name] = Object.assign({}, pzCanvasObject[_this.state.pzCurrentView][pzObject.name], { 'left': pzObject.left, 'top': 2048, 'scaleX': pzObject.scaleX, 'scaleY': pzObject.scaleY, 'angle': pzObject.angle });
                _this.setState({ pzCanvasObject: pzCanvasObject });
            }
        }, _this.pzFCanvasUploadImageAnimation = function (imgObj, pzCanvas) {
            var scaleVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.05;
            var maxSacaleVal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;

            setTimeout(function animate() {
                imgObj.scaleX = imgObj.scaleX + scaleVal;
                imgObj.scaleY = imgObj.scaleY + scaleVal;
                pzCanvas.renderAll();
                if (imgScaleX <= maxSacaleVal) {
                    setTimeout(animate, 50);
                }
            }, 50);
        }, _this.pzToggleFullScreen = function () {
            _this.setState({ fullScreen: !_this.state.fullScreen });
        }, _this.pzToggleFullScreenOLD = function () {
            var fullScreen = _this.state.fullScreen;
            if (fullScreen == 0) {
                fullScreen = 1;
            } else if (fullScreen == 1) {
                fullScreen = 2;
            } else if (fullScreen == 2) {
                fullScreen = 1;
            } else {
                fullScreen = 0;
            }

            _this.setState({ fullScreen: fullScreen });
        }, _this.pzUpdateHistoryStack = function (obj) {
            var _this$pzHistoryStack = _extends({}, _this.pzHistoryStack),
                past = _this$pzHistoryStack.past,
                present = _this$pzHistoryStack.present;

            var newArray = [];
            if (Object.keys(past).length > 0) {
                newArray.push.apply(newArray, _toConsumableArray(past));
                if (Object.keys(present).length > 0) {
                    newArray.push.apply(newArray, _toConsumableArray(present));
                }
                if (newArray) {
                    _this.pzHistoryStack['past'] = [].concat(newArray);
                }
            } else if (Object.keys(present).length > 0) {
                _this.pzHistoryStack['past'] = [].concat(_toConsumableArray(present));
            }
            _this.pzHistoryStack['present'] = [_extends({}, obj)];
        }, _this.pzUndoRedoHandler = function (type) {
            var _this$pzHistoryStack2 = _extends({}, _this.pzHistoryStack),
                past = _this$pzHistoryStack2.past,
                present = _this$pzHistoryStack2.present,
                future = _this$pzHistoryStack2.future;

            switch (type) {
                case 'UNDO':
                    if (present.length <= 0) {
                        return false;
                    }
                    var previous = past && past.length > 0 ? past[past.length - 1] : '';
                    var newPast = past && past.length > 0 ? past.slice(0, past.length - 1) : '';
                    var mergedArray = [].concat(_toConsumableArray(present), _toConsumableArray(future));
                    var newObj = {
                        past: newPast,
                        present: previous ? [_extends({}, previous)] : [],
                        future: [].concat(_toConsumableArray(mergedArray))
                    };
                    _this.pzHistoryStack = _extends({}, newObj);
                    if (Object.keys(present[0]).length > 0 || Object.keys(previous).length > 0) {
                        _this.pzUpdateCanvasObject(present[0], previous);
                    }
                    break;
                case 'REDO':
                    if (future.length <= 0) {
                        return false;
                    }
                    var next = future[0];
                    var newFuture = future.slice(1);
                    var redoObj = {
                        past: [].concat(_toConsumableArray(past), _toConsumableArray(present)),
                        present: [_extends({}, next)],
                        future: newFuture
                    };
                    _this.pzHistoryStack = _extends({}, redoObj);
                    _this.pzCreateCanvasObject(future[0]);
            }
        }, _this.pzUpdateCanvasObject = function (obj, prevObj) {
            var pzCanvasObject = _this.state.pzCanvasObject;

            var loopCounter = 0;
            var canvasObjectLength = Object.keys(pzCanvasObject).length;

            if (obj) {

                Object.keys(pzCanvasObject).map(function (canvasObj, canvasObjIdx) {
                    var currCanvasObj = _extends({}, pzCanvasObject[canvasObj]);
                    if (currCanvasObj[obj.name]) {
                        delete currCanvasObj[obj.name];
                        pzCanvasObject[canvasObj] = _extends({}, currCanvasObj);
                    }
                    loopCounter++;
                });

                if (loopCounter == canvasObjectLength) {
                    if (prevObj) {
                        _this.pzCreateCanvasObject(prevObj, pzCanvasObject);
                    } else {
                        _this.setState({ pzCanvasObject: pzCanvasObject }, function () {
                            _this.pzReloadCanvasObjects();
                        });
                    }
                }
            }
        }, _this.pzCreateCanvasObject = function (params) {
            var pzCanvasObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.pzCanvasObject;

            var tabAttrOptionImages = params.tabAttrImages;
            var pzImgUrl = _this.state.pzImgUrl;

            var pzOptionImageObj = {};
            var parsedOptionPos = params.optImgPos ? JSON.parse(params.optImgPos) : '';
            var loopCounter = 0;

            tabAttrOptionImages && Object.keys(tabAttrOptionImages).length > 0 && Object.keys(tabAttrOptionImages).map(function (optionImageViewId) {
                if (!pzCanvasObject[optionImageViewId][params.name]) {
                    pzCanvasObject[optionImageViewId][params.name] = {};
                }
                var optionPosition = optionImageViewId in parsedOptionPos ? parsedOptionPos[optionImageViewId] : '';
                var imageUrl = tabAttrOptionImages[optionImageViewId] ? pzImgUrl.concat(tabAttrOptionImages[optionImageViewId]) : '';
                pzOptionImageObj = {
                    "type": "image",
                    "name": params.name,
                    "src": imageUrl,
                    "layerno": params.layerNo ? params.layerNo : 1,
                    "width": optionPosition && optionPosition['width '] ? parseFloat(optionPosition['width']) : 0,
                    "height": optionPosition && optionPosition['height'] ? parseFloat(optionPosition['height']) : 0,
                    "left": 0, //(optionPosition && optionPosition['left']) ? optionPosition['left'] : 0,
                    "top": 2048, //(optionPosition && optionPosition['top']) ? optionPosition['top'] : 0,
                    "scaleX": optionPosition && optionPosition['scaleX'] ? optionPosition['scaleX'] : 1,
                    "scaleY": optionPosition && optionPosition['scaleY'] ? optionPosition['scaleY'] : 1,
                    "angle": optionPosition ? optionPosition['angle'] : 0,
                    "tabCode": '',
                    "optionCode": '',
                    "selectable": false,
                    "hasControls": false,
                    "hasBorders": false,
                    "opacity": 1,
                    "crossOrigin": "anonymous"
                };
                pzCanvasObject[optionImageViewId][params.name][0] = Object.assign({}, _extends({}, pzOptionImageObj, { 'opacity': 1 }));
                loopCounter++;
            });
            if (loopCounter == Object.keys(tabAttrOptionImages).length) {
                _this.setState({ pzCanvasObject: pzCanvasObject }, function () {
                    _this.pzReloadCanvasObjects();
                });
            }
        }, _this.pzSaveCanvasImage = async function () {
            var canvasDataUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            var imagedata = {};
            imagedata.src = canvasDataUrl;
            var pzAPIURL = _this.state.pzApiUrl;
            //var saveForLaterResponse = await fetch('https://devcloud.productimize.com/v3/promizenode/convertCanvasToImage', {
            var saveForLaterResponse = await fetch(pzAPIURL + "convertCanvasToImage", {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(imagedata),
                method: "POST"
            });
            var response = await saveForLaterResponse.json();
            console.log("file path ", response);
            return response.filePath;
        }, _this.pzGetSelectedValuesForCart = function (pzCanvasObject) {
            var cartObject = {};
            var imageProperty = {};
            var currViewId = 1;
            var pzSelectedObjectCount = 0;
            //Object.keys(pzCanvasObject).length > 0 && Object.keys(pzCanvasObject).map((view_id, view_index) => {
            var objects = pzCanvasObject;
            var viewName = void 0;
            viewName = "View1";

            imageProperty[viewName] = {
                'imageinfo': {},
                'textinfo': {}
            };
            var uploadedImages = [];
            var uploadImageCount = 0;
            var imageCount = {
                'backgroundFrontImage': 0,
                'backgroundBackImage': 0,
                'logoFrontImage': 0,
                'logoBackImage': 0
            };
            var uploadImgInc = 0;
            var textCount = 0;
            Object.keys(objects).length > 0 && Object.keys(objects).map(function (obj_id, obj_index) {
                if (obj_id !== 'baseImage') {
                    pzSelectedObjectCount = 1;
                    if (objects[obj_id].customType == 'uploadimage' || objects[obj_id].customType == 'image') {
                        if (objects[obj_id].src) {
                            uploadedImages.push(objects[obj_id].src);

                            var attributeName = objects[obj_id].attribute_name;
                            attributeName = attributeName && attributeName.toLowerCase().includes('background') ? attributeName.toUpperCase() + ' ' : '';

                            if (objects[obj_id].partNames && objects[obj_id].partNames[0] == "outside") {
                                attributeName += 'FRONT IMAGE';
                                if (attributeName && attributeName.toLowerCase().includes('background')) {
                                    imageCount.backgroundFrontImage++;
                                    uploadImageCount = imageCount.backgroundFrontImage;
                                } else {
                                    imageCount.logoFrontImage++;
                                    uploadImageCount = imageCount.logoFrontImage;
                                }
                            }
                            if (objects[obj_id].partNames && objects[obj_id].partNames[0] == "inside") {
                                attributeName += 'BACK IMAGE';
                                if (attributeName && attributeName.includes('Background')) {
                                    imageCount.backgroundBackImage++;
                                    uploadImageCount = imageCount.backgroundBackImage;
                                } else {
                                    imageCount.logoBackImage++;
                                    uploadImageCount = imageCount.logoBackImage;
                                }
                            }
                            uploadImgInc++;
                            imageProperty[viewName]['imageinfo'][uploadImgInc] = {
                                'src': objects[obj_id].originalImageSrc,
                                /*  'left': objects[obj_id].left,
                                 'top': objects[obj_id].top,
                                 'width': objects[obj_id].width,
                                 'height': objects[obj_id].height,
                                 'angle': objects[obj_id].angle,
                                 'scaleX': objects[obj_id].scaleX,
                                 'scaleY': objects[obj_id].scaleY, */
                                'printing': 1,
                                'attribute_name': attributeName,
                                'sku': objects[obj_id].option_sku,
                                'imageSpace': objects[obj_id].objectSpacing + "px"
                            };
                            cartObject[attributeName + parseInt(uploadImageCount)] = objects[obj_id].originalImageSrc;
                            if (objects[obj_id].objectSpacing) {
                                cartObject[attributeName + parseInt(uploadImageCount) + ' SPACE'] = objects[obj_id].objectSpacing + 'px';
                            }
                        }
                    } else if (objects[obj_id].customType == 'text') {
                        if ('text' in objects[obj_id] && objects[obj_id].text != "") {
                            var _attributeName = objects[obj_id].attribute_name;
                            /* if (objects[obj_id].tab_name.toLowerCase().includes('front')) {
                                attributeName = 'FRONT TEXT';
                            }
                            else if (objects[obj_id].tab_name.toLowerCase().includes('back')) {
                                attributeName = 'BACK TEXT';
                            } */

                            if (objects[obj_id].partNames[0] == "outside") {
                                _attributeName = 'FRONT TEXT';
                            } else if (objects[obj_id].partNames[0] == "inside") {
                                _attributeName = 'BACK TEXT';
                            }

                            textCount++;
                            imageProperty[viewName]['textinfo'][textCount] = {
                                'text': objects[obj_id].text,
                                'fontFamily': objects[obj_id].fontFamily,
                                'fontColor': objects[obj_id].fill ? objects[obj_id].fill.toUpperCase() : '',
                                'fontWeight': _this.pzCapitalizeFirstLetter(objects[obj_id].fontWeight),
                                'fontStyle': objects[obj_id].fontStyle,
                                'fontSize': objects[obj_id].fontSize + "px",
                                /*  'left': objects[obj_id].left,
                                 'top': objects[obj_id].top,
                                 'width': objects[obj_id].width,
                                 'height': objects[obj_id].height,
                                 'angle': objects[obj_id].angle,
                                 'scaleX': objects[obj_id].scaleX,
                                 'scaleY': objects[obj_id].scaleY, */
                                'printing': 1,
                                'attribute_name': _attributeName,
                                'textSpace': objects[obj_id].objectSpacing + 'px'
                            };
                            cartObject[_attributeName] = objects[obj_id].text;

                            if (objects[obj_id].option_sku) {
                                cartObject[_attributeName + " SKU"] = objects[obj_id].option_sku;
                            }
                            if (objects[obj_id].fontFamily) {
                                cartObject[_attributeName + ' FONT FAMILY'] = objects[obj_id].fontFamily;
                            }
                            if (objects[obj_id].fill) {
                                cartObject[_attributeName + ' FONT COLOR'] = objects[obj_id].fill.toUpperCase();
                            }
                            if (objects[obj_id].fontSize) {
                                cartObject[_attributeName + ' FONT SIZE'] = objects[obj_id].fontSize + "px";
                            }
                            if (objects[obj_id].objectSpacing) {
                                cartObject[_attributeName + ' SPACE'] = objects[obj_id].objectSpacing + 'px';
                            }

                            //if (objects[obj_id].fontStyle) {
                            //var fontStyle = JSON.parse(objects[obj_id].fontStyle);
                            var textKey = _attributeName;

                            if (objects[obj_id].fontWeight) {
                                cartObject[textKey + ' FONT WEIGHT'] = _this.pzCapitalizeFirstLetter(objects[obj_id].fontWeight);
                            }
                            if (objects[obj_id].fontStyle) {
                                cartObject[textKey + ' FONT STYLE'] = _this.pzCapitalizeFirstLetter(objects[obj_id].fontStyle);
                            }
                            if (objects[obj_id].underline) {
                                cartObject[textKey + ' UNDERLINE'] = 'Yes';
                                imageProperty[viewName]['textinfo'][textCount]['underline'] = 'Yes';
                            }
                        }
                    } else if (objects[obj_id].tab_name) {
                        if (objects[obj_id].colorCode && objects[obj_id].tab_name.toLowerCase().includes('color')) {
                            cartObject[objects[obj_id].tab_name.toUpperCase()] = objects[obj_id].colorCode.toUpperCase();
                            imageProperty[viewName][objects[obj_id].tab_name] = objects[obj_id].colorCode.toUpperCase();
                        } else {
                            if ('checked' in objects[obj_id] && objects[obj_id].tab_name.toLowerCase().includes('front text and image')) {
                                if (objects[obj_id].checked == 1) {
                                    var optionName = 'Apply the same Front Text and Image to the back side of lanyards';
                                    cartObject[optionName] = 'Yes';
                                    imageProperty[viewName][optionName] = 'Yes';
                                }
                            } else {
                               if (objects[obj_id].tab_name.toLowerCase() == 'width') {
                                cartObject[objects[obj_id].tab_name.toUpperCase()] = objects[obj_id].option_name;
                                imageProperty[viewName][objects[obj_id].tab_name] = objects[obj_id].option_name;

                                cartObject['LENGTH'] = '36"';
                                imageProperty[viewName]['LENGTH'] = '36"';

                              }
                              else {
                                  cartObject[objects[obj_id].tab_name.toUpperCase()] = objects[obj_id].option_name;
                                  imageProperty[viewName][objects[obj_id].tab_name] = objects[obj_id].option_name;
                              }
                                /*if (objects[obj_id].bulk_pricing) {
                                    cartObject["bulk_pricing"] = objects[obj_id].bulk_pricing;
                                }*/
                            }
                        }
                        if (objects[obj_id].option_sku) {
                            cartObject['SKU'] = objects[obj_id].option_sku;
                            imageProperty[viewName]['SKU'] = objects[obj_id].option_sku;
                        }
                    }
                }
            });
            //})
            return pzSelectedObjectCount > 0 ? { cartObject: cartObject, imageProperty: imageProperty } : null;
        }, _this.pzGetSelectedValuesForApp = function (pzCanvasObject) {
            var selectedObject = {};
            var currViewId = 1;
            var pzSelectedObjectCount = 0;
            var objects = pzCanvasObject;
            var viewName = 'View ' + currViewId++;
            selectedObject[viewName] = {
                'imageinfo': {},
                'textinfo': {}
            };
            var uploadedImages = [];
            var uploadImageCount = 0;
            var textCount = 0;
            Object.keys(objects).length > 0 && Object.keys(objects).map(function (obj_id, view_index) {
                //console.log(objects[obj_id])
                if (obj_id !== 'baseImage') {
                    pzSelectedObjectCount = 1;
                    if (objects[obj_id].customType == 'uploadimage' || objects[obj_id].customType == 'image') {
                        var attributeName = objects[obj_id].attribute_name;
                        if (objects[obj_id].partNames && objects[obj_id].partNames[0] == "outside") {
                            attributeName = 'FRONT IMAGE ';
                        }
                        if (objects[obj_id].partNames && objects[obj_id].partNames[0] == "inside") {
                            attributeName = 'BACK IMAGE ';
                        }
                        uploadedImages.push(objects[obj_id].src);
                        selectedObject[viewName]['imageinfo'][uploadImageCount++] = {
                            'src': objects[obj_id].src,
                            'left': objects[obj_id].left,
                            'top': objects[obj_id].top,
                            'width': objects[obj_id].width,
                            'height': objects[obj_id].height,
                            'angle': objects[obj_id].angle,
                            'scaleX': objects[obj_id].scaleX,
                            'scaleY': objects[obj_id].scaleY,
                            'printing': 1,
                            'attribute_name': attributeName,
                            'tab_name': objects[obj_id].tab_name
                        };
                    } else if (objects[obj_id].customType == 'text') {
                        var _attributeName2 = objects[obj_id].attribute_name;
                        if (objects[obj_id].tab_name.toLowerCase().includes('front')) {
                            _attributeName2 = 'FRONT TEXT';
                        } else if (objects[obj_id].tab_name.toLowerCase().includes('back')) {
                            _attributeName2 = 'BACK TEXT';
                        }
                        selectedObject[viewName]['textinfo'][textCount++] = {
                            'text': objects[obj_id].text,
                            'fontFamily': objects[obj_id].fontFamily,
                            'fontColor': objects[obj_id].fill,
                            'fontStyle': objects[obj_id].fontStyle,
                            'fontSize': objects[obj_id].fontSize,
                            'left': objects[obj_id].left,
                            'top': objects[obj_id].top,
                            'width': objects[obj_id].width,
                            'height': objects[obj_id].height,
                            'angle': objects[obj_id].angle,
                            'scaleX': objects[obj_id].scaleX,
                            'scaleY': objects[obj_id].scaleY,
                            'printing': 1,
                            'attribute_name': _attributeName2
                        };
                    } else if (objects[obj_id].tab_name) {
                        selectedObject[viewName][objects[obj_id].tab_name] = objects[obj_id].option_name;
                    }
                    if (objects[obj_id].option_price) {
                        selectedObject[viewName]['Price'] = objects[obj_id].option_price;
                    }
                }
            });
            // })
            //console.log(selectedObject)
            return pzSelectedObjectCount > 0 ? selectedObject : null;
        }, _this.fileReader = function (blob) {
            return new Promise(function (resolve) {
                var reader = new FileReader();
                reader.onload = function () {
                    return resolve(reader.result);
                };
                reader.readAsDataURL(blob);
            });
        }, _this.loadimage = function (url) {
            return new Promise(function (resolve) {
                var imageObj = new Image();
                imageObj.src = url;
                imageObj.crossOrigin = "Anonymous";
                imageObj.onload = function () {
                    return resolve(imageObj);
                };
            });
        }, _this.pzGetCombinedImage = function () {          
            return new Promise(async function (resolve) {
                var positions = [{ x: 105, y: 10, z: 0 }, { x: -105, y: 10, z: 0 }];
                var canvasDataUrl = await _this.state.promizeThreeDObj.getView(positions);
                var viewName = ['Front', 'Back'];

                if (canvasDataUrl && canvasDataUrl.length > 0) {
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    ctx.globalAlpha = 0;

                    var logoUrl = _this.state.pzIconsPath + "Wristbands.com_Logo_Final_500px_black.png";
                    var logoBlack = _this.state.pzIconsPath + "logo-black.png";
                    if (_this.state.pzCustomizer.product.domain_id != 751 && _this.state.pzCustomizer.product.domain_id != 681) {
                        logoUrl = _this.state.pzIconsPath + 'logo_color.png';
                        logoBlack = _this.state.pzIconsPath + 'logo_black.png';
                    }
                    var blob = await fetch(logoUrl).then(function (r) {
                        return r.blob();
                    });
                    var logo = await _this.pzGetUploadImage(blob);

                    /* loop through images */
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = canvasDataUrl.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var _step$value = _slicedToArray(_step.value, 2),
                                i = _step$value[0],
                                url = _step$value[1];

                            var _image = await _this.pzDownloadImageByUrl(url);
                            var imgHalfWidth = _image.height * (60 / 296);
                            var imgWidth = imgHalfWidth * 2;
                            var logoWidth = _image.height * (110 / 296);
                            var logoHeight = logoWidth * (logo.height / logo.width);
                            var logoPadding = _image.height * (10 / 296);
                            var imagePadding = _image.height * (100 / 296);
                            var imagePosX = imagePadding * (i + 1) + imgWidth * i;
                            var imagePosY = 0 + logoHeight + logoPadding;
                            var imageClipX = _image.width / 2 - imgHalfWidth;
                            var imageClipY = 0;
                            var fontSize = _image.height * (20 / 296);
                            var fontPosX = imagePosX + imgHalfWidth;
                            var fontPosY = _image.height + logoHeight + logoPadding + fontSize * 1.5;

                            if (i == 0) {
                                /* set canvas dimension */
                                canvas.width = imgWidth * 2 + imagePadding * 3;
                                canvas.height = _image.height + fontSize * 3 + logoHeight + logoPadding;

                                /* set background color */
                                var gradient = ctx.createRadialGradient(canvas.width / 2, canvas.height / 2, 0, canvas.width / 2, canvas.height / 2, canvas.width / 2);
                                gradient.addColorStop(0, '#f5f5f5');
                                gradient.addColorStop(1, '#d6d6d6');
                                ctx.fillStyle = gradient;
                                ctx.fillRect(0, 0, canvas.width, canvas.height);

                                /* set logo */
                                ctx.drawImage(logo, logoPadding, logoPadding, logoWidth, logoHeight);
                            }
                            /* set text */
                            ctx.font = fontSize + 'px ' + _this.state.pzDownloadCartImageFontFamily;
                            ctx.textAlign = "center";
                            ctx.fillStyle = "black";
                            ctx.fillText(viewName[i], fontPosX, fontPosY);

                            /* set image */
                            ctx.drawImage(_image, imageClipX, imageClipY, imgWidth, _image.height, imagePosX, imagePosY, imgWidth, _image.height);
                        }

                        /* create watermark */
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    var waterMarkLogo = await _this.pzDownloadImageByUrl(logoBlack);
                    var waterMarkLogoScale = canvas.height * (0.72 / 296);
                    ctx.globalAlpha = 0.2;
                    ctx.save();
                    ctx.translate(canvas.width / 2, canvas.height / 2);
                    ctx.rotate(-30 * Math.PI / 180);
                    ctx.drawImage(waterMarkLogo, -(waterMarkLogo.width * waterMarkLogoScale) / 2, -(waterMarkLogo.height * waterMarkLogoScale) / 2, waterMarkLogo.width * waterMarkLogoScale, waterMarkLogo.height * waterMarkLogoScale);
                    ctx.restore();

                    /* download image */
                    var image = canvas.toDataURL("image/png");
                    resolve(image);
                }
            });
        }, _this.pzCheckRequiredFields = function () {
            var pzCanvasObject = _this.state.pzCanvasObject;
            var fieldFound = false;
            var pzActiveOptions = _this.state.pzActiveOptions;
            //debugger;
            return new Promise(async function (resolve) {
                var isSilkScreen = false,
                    isDyesub = false;
                if (pzActiveOptions && Object.keys(pzActiveOptions).length > 0) {
                    for (var objKey in pzActiveOptions) {
                        var currActionOptions = pzActiveOptions[objKey];
                        var findIdx = currActionOptions.findIndex(function (element) {
                            return typeof element === "string" && element.indexOf('silkscreen') !== -1;
                        });
                        if (findIdx >= 0) {
                            isSilkScreen = true;
                            break;
                        }
                        var findIdxDyesub = currActionOptions.findIndex(function (element) {
                            return typeof element === "string" && element.indexOf('dyesub') !== -1;
                        });
                        //console.log("findIdxDyesub ", findIdxDyesub)
                        if (findIdxDyesub > -1) {
                            isDyesub = true;
                            break;
                        }
                    }
                }
                if (isSilkScreen || isDyesub) {
                    Object.keys(pzCanvasObject).length > 0 && Object.keys(pzCanvasObject).map(function (objKey, obj_index) {
                        if (isSilkScreen && (pzCanvasObject[objKey].customType == 'text' && pzCanvasObject[objKey].text || pzCanvasObject[objKey].customType == 'uploadimage' && pzCanvasObject[objKey].src)) {
                            fieldFound = true;
                        } else if (isDyesub && (pzCanvasObject[objKey].customType == 'text' && pzCanvasObject[objKey].text || pzCanvasObject[objKey].customType == 'uploadimage' && pzCanvasObject[objKey].src || pzCanvasObject[objKey].customType == 'option' && pzCanvasObject[objKey].type == 'image' && pzCanvasObject[objKey].src || objKey.includes('background'))) {
                            fieldFound = true;
                        }
                    });
                } else {
                    fieldFound = true;
                }

                if (fieldFound) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        }, _this.pzAddToCart = async function () {
            _this.setState({ 'pzPageLoader': true });
            var requiredValidation = await _this.pzCheckRequiredFields();
            if (!requiredValidation) {
                _this.setState({ 'pzPageLoader': false, pzErrorDialogPopup: true });
            } else {
                var _this$state4 = _this.state,
                    pzCanvasObject = _this$state4.pzCanvasObject,
                    pzProductPrice = _this$state4.pzProductPrice,
                    pzActiveOptions = _this$state4.pzActiveOptions,
                    pzCustomizer = _this$state4.pzCustomizer,
                    pzApiUrl = _this$state4.pzApiUrl,
                    pzImgUrl = _this$state4.pzImgUrl,
                    pzReplaceImg = _this$state4.pzReplaceImg;

                var variantid = document.getElementById("variant_id") ? document.getElementById("variant_id").value : '';
                var qty = document.getElementById('pz-qty-field').value;
                var data = {};
                var selectedObject = _this.pzGetSelectedValuesForCart(pzCanvasObject);
                console.log("selectedObject ", selectedObject);
                addtocart(); //shopify

                var canvasDataUrl = await _this.pzGetCombinedImage();
                var pzSetState = _this.pzSetState;
                //console.log('canvas data url ', canvasDataUrl)


                if (selectedObject) {
                    _this.pzSaveCanvasImage(canvasDataUrl).then(function (saveCanveasImageresponse) {
                        var pzSelectedObjects = _extends({}, selectedObject.cartObject);
                        var pzImageData = _extends({}, selectedObject.imageProperty);
                        pzSelectedObjects['DESIGNED IMAGE'] = saveCanveasImageresponse ? pzImgUrl + saveCanveasImageresponse.replace(pzReplaceImg, '') : '';
                        pzImageData['View1']['customImage'] = saveCanveasImageresponse ? pzImgUrl + saveCanveasImageresponse.replace(pzReplaceImg, '') : '';

                        console.log("selectedObject ", pzSelectedObjects);

                        $.ajax({
                            url: "/cart/add.js",
                            type: "POST",
                            dataType: "json",
                            data: { quantity: qty, id: custom_variant, properties: pzSelectedObjects },
                            success: function success(res) {
                                fetch(pzApiUrl + 'saveCartProperty', {
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json'
                                    },
                                    method: "POST",
                                    //body: JSON.stringify({ cart_item_id: res.id, domain_id: pzCustomizer.product.domain_id, custom_properties: pzImageData })
                                    body: JSON.stringify({ cart_item_id: res.id, domain_id: pzCustomizer.product.domain_id, custom_properties: pzImageData })
                                }).then(function (res) {
                                    return res.json();
                                }).then(function (response) {
                                    console.log("===resonse===", response);
                                });
                                window.location.href = "/cart";
                            },
                            error: function error() {
                                alert("Sorry something went wrong..");
                            },
                            complete: function complete() {
                                pzSetState('pzPageLoader', false);
                            }
                        });
                    });
                } else {
                    pzSetState('pzPageLoader', false);
                    alert("No item is selected. Please select some items before hit add to cart");
                }
            }
        }, _this.pzCreateCartProperties = function (pzObjType, pzObjectParams) {
            var pzCurrentView = 0;
            //let pzColorFilter = pzColorFilters(pzObjectParams.image_color_settings, pzObjectParams.colorCode, pzObjType);
            if (pzObjType == 'boundary') {
                return '';
            } else if (pzObjType == 'text') {
                var pzFCanvasObject = {
                    name: 'FObject_text_' + pzObjectParams.promize_tab_attribute_id + '_' + pzObjectParams.index,
                    fontSize: pzObjectParams.fontSize,
                    textAlign: pzObjectParams.textAlign,
                    fill: pzObjectParams.fill,
                    textDecoration: 'none',
                    underline: false,
                    fontWeight: pzObjectParams.fontWeight,
                    fontFamily: pzObjectParams.fontFamily,
                    fontStyle: pzObjectParams.fontStyle,
                    editable: false,
                    selectable: true,
                    hasControls: true,
                    boundary: pzObjectParams.boundary,
                    layerno: pzObjectParams.tab_layer_no,
                    type: 'textbox',
                    left: pzObjectParams.left,
                    //height: pzObjectParams.height,
                    top: 2048,
                    //globalCompositeOperation: 'source-atop',
                    showBoundary: false,
                    showTextOutsideBoundary: 0,
                    Originaltext: pzObjectParams.Originaltext,
                    textWidth: pzObjectParams.width,
                    textHeight: pzObjectParams.height,
                    inCanvas: pzObjectParams.inCanvas,
                    fontFamilyFile: pzObjectParams.fontFamilyFile,
                    //centeredRotation: true,
                    //centeredScaling: true
                    // skewX: 10,
                    // skewY: 50,
                    customType: 'text',
                    tabAttrId: pzObjectParams.promize_tab_attribute_id,
                    tabId: pzObjectParams.promize_tab_id,
                    option_name: pzObjectParams.promize_attribute_text_value.text_name ? pzObjectParams.promize_attribute_text_value.text_name : '',
                    option_price: pzObjectParams.promize_attribute_text_value.text_price,
                    "option_sku": pzObjectParams.promize_attribute_text_value.text_sku ? pzObjectParams.promize_attribute_text_value.text_sku : '',
                    tab_name: pzObjectParams.tab_name,
                    bulk_pricing: pzObjectParams.bulk_pricing ? pzObjectParams.bulk_pricing : 0
                };
                /* if (pzFCanvasObject.showTextOutsideBoundary == 0) {
                    pzFCanvasObject.clipTo = pzCliping(pzFCanvasObject)
                }
                pzFCanvasObject = pzChangeTextProperty(pzFCanvasObject, pzObjectParams); */
                return pzFCanvasObject;
            } else if (pzObjType == 'uploadimage') {
                var left = 0,
                    top = 0,
                    width = 1000,
                    height = 1000,
                    scaleX = 1,
                    scaleY = 1,
                    angle = 0;
                if (pzObjectParams.boundary) {
                    var _pzObjectParams$bound = pzObjectParams.boundary,
                        _pzObjectParams$bound2 = _pzObjectParams$bound.left,
                        left = _pzObjectParams$bound2 === undefined ? 0 : _pzObjectParams$bound2,
                        _pzObjectParams$bound3 = _pzObjectParams$bound.top,
                        top = _pzObjectParams$bound3 === undefined ? 0 : _pzObjectParams$bound3,
                        _pzObjectParams$bound4 = _pzObjectParams$bound.width,
                        width = _pzObjectParams$bound4 === undefined ? 1000 : _pzObjectParams$bound4,
                        _pzObjectParams$bound5 = _pzObjectParams$bound.height,
                        height = _pzObjectParams$bound5 === undefined ? 1000 : _pzObjectParams$bound5,
                        _pzObjectParams$bound6 = _pzObjectParams$bound.scaleX,
                        scaleX = _pzObjectParams$bound6 === undefined ? 1 : _pzObjectParams$bound6,
                        _pzObjectParams$bound7 = _pzObjectParams$bound.scaleY,
                        scaleY = _pzObjectParams$bound7 === undefined ? 1 : _pzObjectParams$bound7,
                        _pzObjectParams$bound8 = _pzObjectParams$bound.angle,
                        angle = _pzObjectParams$bound8 === undefined ? 0 : _pzObjectParams$bound8;
                }
                var _pzFCanvasObject = {
                    "type": "image",
                    "name": "FObject_image_" + pzObjectParams.promize_tab_attribute_id + '_' + pzObjectParams.index + '_' + pzObjectParams.imageIndex,
                    "src": pzObjectParams.src,
                    "layerno": pzObjectParams.tab_layer_no ? pzObjectParams.tab_layer_no : 1,
                    "originalWidth": pzObjectParams.originalWidth,
                    // "height": height,
                    /*"left": left,
                    "top": top,
                    "scaleX": scaleX,
                    "scaleY": scaleY,
                    "angle": angle,*/
                    "boundary": pzObjectParams.boundary,
                    "showBoundary": false,
                    //"filters": pzColorFilter,
                    "tabId": pzObjectParams.promize_tab_id,
                    "tabAttrId": pzObjectParams.promize_tab_attribute_id,
                    "tabAttrValueId": pzObjectParams.promize_tab_image_attribute_values_id,
                    "selectable": false,
                    "hasControls": false,
                    "hasBorders": false,
                    "opacity": 1,
                    "crossOrigin": "anonymous",
                    "customType": "uploadimage",
                    "showTextOutsideBoundary": 0,
                    "option_name": pzObjectParams.src,
                    "option_price": pzObjectParams.promize_attribute_image_value.image_price,
                    "option_sku": pzObjectParams.promize_attribute_image_value.image_sku ? pzObjectParams.promize_attribute_image_value.image_sku : '',
                    "tab_name": pzObjectParams.tab_name,
                    bulk_pricing: pzObjectParams.bulk_pricing ? pzObjectParams.bulk_pricing : 0,
                    originalImageSrc: pzObjectParams.originalImageSrc ? pzObjectParams.originalImageSrc : pzObjectParams.src,
                    dpiMatched: pzObjectParams.dpiMatched
                };
                /* if (pzFCanvasObject.showTextOutsideBoundary == 0) {
                    pzFCanvasObject.clipTo = pzCliping(pzFCanvasObject)
                }
                pzFCanvasObject = pzChangeImageProperty(pzFCanvasObject, pzObjectParams); */
                return _pzFCanvasObject;
            } else {
                var parsedPosition = pzObjectParams.option_position ? JSON.parse(pzObjectParams.option_position) : '';

                var _ref2 = parsedPosition && pzCurrentView in parsedPosition ? parsedPosition[pzCurrentView] : '',
                    _ref2$left = _ref2.left,
                    _left = _ref2$left === undefined ? 0 : _ref2$left,
                    _ref2$top = _ref2.top,
                    _top = _ref2$top === undefined ? 2048 : _ref2$top,
                    _ref2$width = _ref2.width,
                    _width = _ref2$width === undefined ? 1000 : _ref2$width,
                    _ref2$height = _ref2.height,
                    _height = _ref2$height === undefined ? 1000 : _ref2$height,
                    _ref2$scaleX = _ref2.scaleX,
                    _scaleX = _ref2$scaleX === undefined ? 1 : _ref2$scaleX,
                    _ref2$scaleY = _ref2.scaleY,
                    _scaleY = _ref2$scaleY === undefined ? 1 : _ref2$scaleY,
                    _ref2$angle = _ref2.angle,
                    _angle = _ref2$angle === undefined ? 0 : _ref2$angle;

                return {
                    "type": "image",
                    "name": "FObject_option_" + pzObjectParams.promize_tab_id,
                    "src": pzObjectParams.src,
                    "layerno": pzObjectParams.tab_layer_no ? pzObjectParams.tab_layer_no : 1,
                    "width": _width,
                    "height": _height,
                    "left": _left,
                    "top": _top,
                    "scaleX": _scaleX,
                    "scaleY": _scaleY,
                    "angle": _angle,
                    //"filters": pzColorFilter,
                    "tabId": pzObjectParams.promize_tab_id,
                    "tabAttrId": pzObjectParams.promize_tab_attribute_id,
                    "tabAttrValueId": pzObjectParams.promize_tab_attribute_values_id,
                    "selectable": false,
                    "hasControls": false,
                    "hasBorders": false,
                    "opacity": 1,
                    "crossOrigin": "anonymous",
                    "value": pzObjectParams.optionValue,
                    "customType": 'option',
                    "option_name": pzObjectParams.promize_attribute_value.option_name ? pzObjectParams.promize_attribute_value.option_name : '',
                    "option_price": pzObjectParams.promize_attribute_value.option_price,
                    "option_sku": pzObjectParams.promize_attribute_value.option_sku ? pzObjectParams.promize_attribute_value.option_sku : '',
                    "tab_name": pzObjectParams.tab_name,
                    "colorCode": pzObjectParams.colorCode ? pzObjectParams.colorCode : '',
                    "thumbImage": pzObjectParams.thumbImage ? pzObjectParams.thumbImage : '',
                    "part_names": pzObjectParams.part_names ? pzObjectParams.part_names : '',
                    "uploadedImageKeys": pzObjectParams.uploadedImageKeys ? pzObjectParams.uploadedImageKeys : '',
                    "sourceOrigin": pzObjectParams.sourceOrigin ? pzObjectParams.sourceOrigin : '',
                    bulk_pricing: pzObjectParams.bulk_pricing ? pzObjectParams.bulk_pricing : 0,
                    'checked': pzObjectParams.checked ? pzObjectParams.checked : 0

                };
            }
        }, _this.pzOpenPopup = async function (pzTabAttribute, pzTab) {

            _this.state.promizeTwoDObj.on('component:part:modified', function (e) {
                if (_this.state.pzPopupCopyToBoth) {
                    //console.log("component MODIFIED", e.detail)
                    var pzPopupData = e.detail.customizationData;
                    var popupUploadData = 'uploadData' in pzPopupData ? pzPopupData['uploadData'] : {};

                    Object.keys(popupUploadData['2d-customization-popup-repeat']).map(async function (repeatViewType, index) {

                        if ("outside" == repeatViewType) {
                            var addedImages = popupUploadData['2d-customization-popup-repeat'][repeatViewType]['addImage'];

                            if (Object.keys(addedImages).length > 0) {
                                //console.log(" coming3")

                                var anotherViewType = "inside";
                                popupUploadData['2d-customization-popup-repeat'][anotherViewType] = {};
                                popupUploadData['2d-customization-popup-repeat'][anotherViewType]['addImage'] = _extends({}, addedImages);

                                Object.keys(addedImages).map(function (imageKey, imgIdx) {
                                    // popupUploadData['2d-customization-popup-repeat'][anotherViewType]['addImage'][imageKey].properties.selectable = false;
                                    // popupUploadData['2d-customization-popup-repeat'][anotherViewType]['addImage'][imageKey].properties.evented = false;

                                    if (imgIdx == Object.keys(addedImages).length - 1) {
                                        var componentData = {
                                            uploadData: _extends({}, popupUploadData)
                                        };

                                        _this.state.promizeTwoDObj.updateComponent(componentData);
                                    }
                                });
                            }
                        }
                    });
                }
            });
            var pzPopupBackgroundAttr = _this.state.pzPopupBackgroundAttr;

            pzPopupBackgroundAttr['tabAttrId'] = pzTabAttribute.promize_tab_attribute_id;
            pzPopupBackgroundAttr['tabId'] = pzTab.promize_tab_id;
            var pzPopupUploadImages = _this.state.pzPopupUploadImages;
            var pzPopupAppliedData = _this.state.pzPopupAppliedData;
            var customizationData = {};

            if (Object.keys(pzPopupAppliedData).length <= 0 || 'repeatData' in pzPopupAppliedData && pzPopupAppliedData['repeatData'].length <= 0 && 'uploadData' in pzPopupAppliedData && pzPopupAppliedData['uploadData'].length <= 0) {
                pzPopupUploadImages = { 'outside': {}, 'inside': {} };
            }
            var viewData = {
                name: 'tag_component',
                component: {
                    name: _this.state.pzBaseType ? _this.state.pzBaseType : '3/4',
                    component: {
                        name: 'tag',
                        views: {
                            outside: {
                                canvas: {
                                    width: 900,
                                    height: 900
                                },
                                thumbRequired: true,
                                overlayImage: _this.state.pzSizeProperties[_this.state.pzBaseType].url,
                                maskData: {
                                    type: 'shape', properties: {
                                        shape: 'rect',
                                        left: 450,
                                        top: 450,
                                        scaleX: 1,
                                        scaleY: 1,
                                        width: 897, //8192 / (8192 / 900),
                                        height: _this.state.pzSizeProperties[_this.state.pzBaseType].maskHeight, //140 / (8192 / 900),
                                        objectCaching: false,
                                        fill: "",
                                        stroke: "#000",
                                        strokeWidth: 0,
                                        originX: "center",
                                        originY: "center",
                                        hasBorders: false,
                                        hasControls: false,
                                        evented: false,
                                        selectable: false
                                    }
                                }

                            },
                            inside: {
                                canvas: {
                                    width: 900,
                                    height: 900
                                },
                                thumbRequired: true,
                                overlayImage: _this.state.pzSizeProperties[_this.state.pzBaseType].url,
                                maskData: {
                                    type: 'shape', properties: {
                                        shape: 'rect',
                                        left: 450,
                                        top: 450,
                                        scaleX: 1,
                                        scaleY: 1,
                                        width: 897, //8192 / (8192 / 900),
                                        height: _this.state.pzSizeProperties[_this.state.pzBaseType].maskHeight, //140 / (8192 / 900),
                                        objectCaching: false,
                                        fill: "",
                                        stroke: "#000",
                                        strokeWidth: 0,
                                        originX: "center",
                                        originY: "center",
                                        hasBorders: false,
                                        hasControls: false,
                                        evented: false,
                                        selectable: false
                                    }
                                }

                            }
                        }
                    }
                }
            };
            await _this.state.promizeTwoDObj.createView(viewData);
            var pzPopupViewType = _this.state.pzPopupViewType;

            var updateViewData = {
                selectView: _this.state.pzPopupViewType,
                transformView: {
                    outside: {
                        panLeft: 20,
                        zoomIn: {
                            point: { x: 450, y: 450 },
                            value: 2
                        }
                    },
                    inside: {
                        panLeft: 20,
                        zoomIn: {
                            point: { x: 450, y: 450 },
                            value: 2
                        }
                    }
                }
            };

            _this.state.promizeTwoDObj.updateView(updateViewData);
            _this.setState({ popup: true, pzPopupBackgroundAttr: pzPopupBackgroundAttr, pzPopupUploadImages: pzPopupUploadImages }, function () {
                //this.applySide(this.state.applyType);
            });
        }, _this.pzPopupUploadImage = function (event) {
            //console.log("pzPopupRepeatUploadImage ", uploadedFile)
            var _this$state5 = _this.state,
                pzPopupBackgroundAttr = _this$state5.pzPopupBackgroundAttr,
                pzPopupViewBasedUploadType = _this$state5.pzPopupViewBasedUploadType,
                pzPopupViewType = _this$state5.pzPopupViewType;


            var pzUploadImageTabAttribute = _this.state.pzCustomizer.attributeImages[pzPopupBackgroundAttr.tabAttrId];
            var imageDetail = _extends({}, pzUploadImageTabAttribute);

            if (_this.state.pzPopupUploadImgErrorMsg != '') {
                _this.setState({ pzPopupUploadImgErrorMsg: "" });
            }
            var uploadedFile = event.target.files[0];
            var imgUploadStatus = _this.pzUploadImageValidation(event, imageDetail);
            //console.log("imgUploadStatus ", imgUploadStatus)

            if (imgUploadStatus['imgStatus']) {
                //if (this.state.pzPopupRepeat) {
                var file = event.target.files[0];
                var reader = new FileReader();
                var pzSetState = _this.setState;
                var pzPopupUploadDPIMsg = _this.state.pzPopupUploadDPIMsg;

                reader.onload = function (f) {
                    var data = f.target.result;
                    var image = new Image();
                    image.src = data;

                    var formData = new FormData();
                    formData.append("imgBase64", data);
                    formData.append("validateImageType", 'dpi');
                    formData.append("validateImageValue", 300);

                    var currApiUrl = 'https://cloud.productimize.com/prokapchn/dpiValidation.php';
                    //fetch(pzApiUrl + "uploadImageWithDpi/" + parseInt(width) + '/' + parseInt(height) + '/2', {
                    fetch(currApiUrl, {
                        method: "POST",
                        body: formData
                    }).then(function (res) {
                        return res.json();
                    }).then(function (response) {
                        //console.log(" VAldation data :: ", response)
                        if (response == 1) {
                            pzPopupUploadDPIMsg = 0;
                        } else {
                            pzPopupUploadDPIMsg = 1;
                        }
                        _this.setState({ pzPopupUploadDPIMsg: pzPopupUploadDPIMsg }, function () {
                            console.log("pzpopup ", pzPopupUploadDPIMsg);
                        });
                    });
                };
                reader.readAsDataURL(file);

                if (_this.state.pzPopupViewBasedUploadType[pzPopupViewType] == 'repeat') {
                    _this.pzPopupRepeatUploadImage(uploadedFile);
                } else {
                    _this.pzPopupSingleUploadImage(uploadedFile);
                }
                event.target.value = "";
            } else {
                _this.setState({ pzPopupUploadImgErrorMsg: imgUploadStatus['imgErrorMsg'] });
            }
        }, _this.pzPopupRemoveImage = function (e, imgData, objKey, viewType) {
            var bothSides = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;


            //console.log('REMOVE OBJ ', imgData)
            //console.log('REMOVE objKey ', objKey)
            //console.log('REMOVE viewType ', viewType)
            var pzPopupUploadImages = _this.state.pzPopupUploadImages;

            // console.log("REMOVE PZPOUP", pzPopupUploadImages)
            if (pzPopupUploadImages[viewType] && pzPopupUploadImages[viewType][objKey]) {
                delete pzPopupUploadImages[viewType][objKey];

                var anotherViewType = "inside";
                if (_this.state.pzPopupCopyToBoth && pzPopupUploadImages[anotherViewType] && pzPopupUploadImages[anotherViewType][objKey]) {
                    delete pzPopupUploadImages[anotherViewType][objKey];
                }

                _this.setState({ pzPopupUploadImages: pzPopupUploadImages }, function () {

                    var customData = {};

                    var ImagePartData = {};
                    var uploadedImageData = {};
                    uploadedImageData['removeImage'] = [];
                    uploadedImageData['removeImage'].push(objKey);
                    if (imgData.customDataType == "repeatData") {
                        var _ImagePartData$viewTy;

                        ImagePartData[viewType] = (_ImagePartData$viewTy = {}, _defineProperty(_ImagePartData$viewTy, 'uploadData', uploadedImageData), _defineProperty(_ImagePartData$viewTy, 'repeatSettings', {
                            objectSpacing: 0
                        }), _ImagePartData$viewTy);
                        if (_this.state.pzPopupCopyToBoth) {
                            var _ImagePartData$anothe;

                            ImagePartData[anotherViewType] = (_ImagePartData$anothe = {}, _defineProperty(_ImagePartData$anothe, 'uploadData', uploadedImageData), _defineProperty(_ImagePartData$anothe, 'repeatSettings', {
                                objectSpacing: 0
                            }), _ImagePartData$anothe);
                        }
                        customData = {
                            repeatData: {
                                '2d-customization-popup-repeat': ImagePartData
                            }
                        };
                    } else {
                        ImagePartData[viewType] = _extends({}, uploadedImageData);
                        if (_this.state.pzPopupCopyToBoth) {
                            ImagePartData[anotherViewType] = _extends({}, uploadedImageData);
                        }
                        customData = {
                            uploadData: {
                                '2d-customization-popup-repeat': ImagePartData
                            }
                        };
                    }

                    console.log("DELETE customData ", customData);
                    _this.state.promizeTwoDObj.updateComponent(customData);
                });
            }
        }, _this.pzPopupRepeatUploadImage = function (uploadedFile) {
            var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            //console.log("pzPopupRepeatUploadImage ", uploadedFile)
            var pzPopupUploadImages = _this.state.pzPopupUploadImages;
            var pzPopupAppliedData = _this.state.promizeTwoDObj.getCustomizationData();

            var fileEvent = uploadedFile;
            var viewType = _this.state.pzPopupViewType;

            var ImagePartData = {};
            var uploadedImageData = {};
            uploadedImageData['removeImage'] = [];

            var popupData = 'repeatData' in pzPopupAppliedData ? pzPopupAppliedData['repeatData'] : {};
            if (Object.keys(popupData).length > 0) {
                //
                Object.keys(popupData['2d-customization-popup-repeat']).map(async function (repeatViewType, index) {
                    if (_this.state.pzPopupCopyToBoth || _this.state.pzPopupViewType == repeatViewType) {
                        var addedImages = {};
                        addedImages = popupData['2d-customization-popup-repeat'][repeatViewType]['uploadData']['addImage'];

                        if (Object.keys(addedImages).length > 0) {
                            var removeImages = [];
                            var normalUploadRemoveImage = [];

                            //console.log("COMPO addedImages ", addedImages)


                            if (Object.keys(addedImages).length > 0) {
                                // normalUploadRemoveImage = [...Object.keys(addedImages)];

                                pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][repeatViewType] = {
                                    removeImage: [].concat(_toConsumableArray(addedImages))
                                };
                                var componentata = {
                                    repeatData: _defineProperty({}, '2d-customization-popup-repeat', _defineProperty({}, repeatViewType, {
                                        uploadData: {
                                            removeImage: [].concat(_toConsumableArray(Object.keys(addedImages)))
                                        }
                                    }))
                                    //console.log("componentata  ==> ", componentata)
                                };_this.state.promizeTwoDObj.updateComponent(componentata);
                            }
                        }
                        //}
                    }
                });
            }

            if (pzPopupUploadImages[viewType]) {
                pzPopupUploadImages[viewType] = {};
            }

            var sizeProperties = _this.state.pzSizeProperties[_this.state.pzBaseType];

            var ImagePartData = {};
            var uploadedImageData = {};
            uploadedImageData['addImage'] = {};
            //uploadedImageData['addImage'][viewType + '_' + (uploadImageCount)] = {
            uploadedImageData['addImage'][viewType + '_repeat'] = {
                image: fileEvent,
                properties: {
                    left: 0,
                    top: 2048,
                    scaleX: 1,
                    scaleY: 1,
                    maxWidth: 4096,
                    maxHeight: sizeProperties.maxHeight,
                    // maskHeight: sizeProperties.maskHeight,
                    applyFullScreen: false,
                    selectable: false,
                    evented: false,
                    layer: 2
                }
            };

            ImagePartData[viewType] = {
                uploadData: uploadedImageData,
                repeatSettings: {
                    spacing: 0,
                    groupSpacing: 0,
                    objectSpacing: {}
                }
            };
            pzPopupUploadImages[viewType][viewType + '_repeat'] = {
                customDataType: 'repeatData',
                addImageKey: 'uploadData',
                key: viewType + '_repeat',
                file: fileEvent
            };

            if (_this.state.pzPopupCopyToBoth) {
                var newViewType = viewType == 'outside' ? 'inside' : viewType;
                ImagePartData[newViewType] = {
                    uploadData: uploadedImageData,
                    repeatSettings: {
                        spacing: 0,
                        groupSpacing: 0,
                        objectSpacing: {}
                    }
                };
                pzPopupUploadImages[newViewType][viewType + '_repeat'] = {
                    customDataType: 'repeatData',
                    addImageKey: 'uploadData',
                    key: viewType + '_repeat',
                    file: fileEvent
                };
            }

            var customData1 = {
                repeatData: {
                    '2d-customization-popup-repeat': ImagePartData
                }
                //console.log("customData1 ", customData1)
            };_this.state.promizeTwoDObj.updateComponent(customData1);

            //console.log("pzPopupUploadImages ", pzPopupUploadImages)

            _this.setState({ pzPopupUploadImages: pzPopupUploadImages });
        }, _this.pzPopupSingleUploadImage = function (uploadedFile, name) {

            var pzPopupUploadImages = _this.state.pzPopupUploadImages;

            var tabId = _this.state.pzActiveTab[_this.state.pzActiveSection];
            var pzCanvasObject = _this.state.pzCanvasObject;
            var pzPopupRepeatUploadImageKeys = _this.state.pzPopupRepeatUploadImageKeys;
            var uploadImageCount = PromizeHome.popupUploadImageCount++;
            var tabData = {};
            if (tabId) {
                tabData = _this.state.pzCustomizer[tabId];
            }
            var fileEvent = uploadedFile;
            var viewType = _this.state.pzPopupViewType;

            if (!pzPopupRepeatUploadImageKeys.includes(name)) {
                pzPopupRepeatUploadImageKeys.push(name);
            }

            var ImagePartData = {};
            var uploadedImageData = {};
            uploadedImageData['addImage'] = {};
            uploadedImageData['addImage'][viewType + '_' + uploadImageCount] = {
                image: fileEvent,
                properties: {
                    left: 2048,
                    top: 2048,
                    scaleX: 1,
                    scaleY: 1,
                    originX: "center",
                    originY: "center",
                    applyFullScreen: false,
                    maxHeight: _this.state.pzSizeProperties[_this.state.pzBaseType].maxHeight,
                    layer: 2,
                    selectable: true,
                    evented: true
                }
            };
            ImagePartData[viewType] = uploadedImageData;

            pzPopupUploadImages[viewType][viewType + '_' + uploadImageCount] = {
                customDataType: 'uploadData',
                addImageKey: '',
                key: viewType + '_' + uploadImageCount,
                file: fileEvent
            };

            if (_this.state.pzPopupCopyToBoth) {
                var newViewType = viewType == 'outside' ? 'inside' : viewType;
                ImagePartData[newViewType] = uploadedImageData;

                pzPopupUploadImages[newViewType][viewType + '_' + uploadImageCount] = {
                    customDataType: 'uploadData',
                    addImageKey: '',
                    key: viewType + '_' + uploadImageCount,
                    file: fileEvent
                };
            }

            var customData1 = {
                //customizationData: {
                //repeatData: ImagePartData
                uploadData: {
                    '2d-customization-popup-repeat': ImagePartData
                    //}
                }

                //console.log("single upload ", customData1)
            };_this.state.promizeTwoDObj.updateComponent(customData1);

            _this.setState({ pzPopupUploadImages: pzPopupUploadImages }, function () {
                console.log("pzPopupUploadImages ", pzPopupUploadImages);
            });
        }, _this.pzPopupRepeat = function (e) {
            var pzPopupViewType = _this.state.pzPopupViewType;
            var pzPopupViewBasedUploadType = _this.state.pzPopupViewBasedUploadType;
            //pzPopupViewBasedUploadType[pzPopupViewType] = (pzPopupViewBasedUploadType[pzPopupViewType] == 'repeat') ? 'upload' : 'repeat';;

            pzPopupViewBasedUploadType[pzPopupViewType] = pzPopupViewBasedUploadType[pzPopupViewType] == 'repeat' ? 'upload' : 'repeat';

            if (_this.state.pzPopupCopyToBoth) {
                pzPopupViewBasedUploadType['inside'] = pzPopupViewBasedUploadType[pzPopupViewType];
            }

            _this.setState({ pzPopupRepeat: !_this.state.pzPopupRepeat, pzPopupViewBasedUploadType: pzPopupViewBasedUploadType }, function () {
                var uploadType = pzPopupViewBasedUploadType[pzPopupViewType] == 'repeat' ? 'repeat' : 'normal';
                _this.pzChangeUploadedImage(uploadType);
            });
        }, _this.pzChangeUploadedImageForBothSides = function (popupApplied2DData, uploadType) {
            var _this$state6 = _this.state,
                pzCanvasObject = _this$state6.pzCanvasObject,
                pzPopupRepeatUploadImageKeys = _this$state6.pzPopupRepeatUploadImageKeys,
                pzPopupUploadImageProperties = _this$state6.pzPopupUploadImageProperties,
                pzPopupUploadImages = _this$state6.pzPopupUploadImages;

            //console.log("popupApplied2DData ", popupApplied2DData)
            //console.log("uploadType " + uploadType)

            if (_this.state.pzPopupCopyToBoth) {
                if (uploadType == 'repeat') {
                    var isPZCanvasObjToBeUpdated = false;
                    var repeatData = {};
                    if (popupApplied2DData.uploadData) {
                        repeatData = popupApplied2DData.uploadData['2d-customization-popup-repeat'];
                    }
                    var ImagePartData = {};
                    var RemoveImagePartData = {};
                    var uploadedImages = Object.keys(repeatData).length > 0 && Object.keys(repeatData).map(async function (repeatDataViewType, viewIndex) {

                        if ("outside" == repeatDataViewType) {

                            var addedImages = repeatData[repeatDataViewType]['addImage'];
                            addedImages = _this.sortObjects(addedImages, ['properties', 'left']);

                            var anotherViewType = "inside";

                            var uploadedImageData = {},
                                removeImageData = {};
                            uploadedImageData['uploadData'] = {};
                            uploadedImageData['uploadData']['addImage'] = {};
                            uploadedImageData['repeatSettings'] = {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: {}
                            };
                            removeImageData['removeImage'] = [];

                            var firstUploadedImageLeft = 0;
                            var groupSpacing = 0;

                            Object.keys(addedImages) && Object.keys(addedImages).map(async function (imageData, index) {
                                var fileEvent = addedImages[imageData]['image'];
                                var imageProperties = _extends({}, addedImages[imageData]['properties']);
                                imageProperties.selectable = false;
                                imageProperties.evented = false;

                                if (index == 0) {
                                    firstUploadedImageLeft = imageProperties['left'] + imageProperties.objWidth / 2;
                                    imageProperties.left = 0;
                                } else {
                                    var tempLeft = imageProperties.left;
                                    var left = firstUploadedImageLeft + imageProperties.objWidth / 2;
                                    // if(left < 0) left = 0
                                    imageProperties.left -= left;
                                    firstUploadedImageLeft = tempLeft + imageProperties.objWidth / 2;
                                    groupSpacing = 0;
                                }

                                if (Object.keys(addedImages).length == 1) {
                                    imageProperties.left = 0;
                                }

                                var objKey = imageData;
                                if (objKey) {
                                    pzPopupUploadImageProperties[objKey] = _extends({}, addedImages[imageData]['properties']);
                                    var canvasDeleteImgKey = "FObject_option_background_" + objKey;
                                    //delete pzPopupUploadImages[objKey];
                                    isPZCanvasObjToBeUpdated = true;
                                    if (canvasDeleteImgKey in pzCanvasObject) {
                                        delete pzCanvasObject[canvasDeleteImgKey];
                                        isPZCanvasObjToBeUpdated = true;
                                    }
                                    removeImageData['removeImage'].push(objKey);
                                    uploadedImageData['uploadData']['addImage'][objKey] = {
                                        image: fileEvent,
                                        properties: imageProperties
                                    };

                                    pzPopupUploadImages[repeatDataViewType][objKey] = {
                                        customDataType: 'repeatData',
                                        addImageKey: '',
                                        key: objKey,
                                        file: fileEvent

                                        //console.log("uploadedImageData", uploadedImageData)
                                    };
                                }
                            });
                            uploadedImageData['repeatSettings'].groupSpacing = groupSpacing;
                            ImagePartData[repeatDataViewType] = Object.assign({}, ImagePartData[repeatDataViewType], _extends({}, uploadedImageData));
                            ImagePartData['inside'] = Object.assign({}, {}, _extends({}, uploadedImageData));

                            //console.log("ImagePartData  ", ImagePartData)
                            RemoveImagePartData[repeatDataViewType] = Object.assign({}, RemoveImagePartData[repeatDataViewType], _extends({}, removeImageData));
                            //console.log("RemoveImagePartData ", RemoveImagePartData);

                        } else {
                            var _addedImages = repeatData[repeatDataViewType]['addImage'];
                            if (Object.keys(_addedImages).length > 0) {
                                if (repeatData[repeatDataViewType]) {
                                    var existingImages = _extends({}, repeatData[repeatDataViewType]['addImage']);
                                    if (Object.keys(existingImages).length > 0) {
                                        RemoveImagePartData[repeatDataViewType] = {
                                            removeImage: [].concat(_toConsumableArray(Object.keys(existingImages)))
                                        };
                                    }
                                }
                            }
                        }
                        if (Object.keys(repeatData).length == viewIndex + 1) {
                            var customData1 = {
                                uploadData: {
                                    '2d-customization-popup-repeat': RemoveImagePartData
                                },
                                repeatData: {
                                    '2d-customization-popup-repeat': ImagePartData
                                }
                            };
                            _this.state.promizeTwoDObj.updateComponent(customData1);

                            _this.setState({ pzCanvasObject: pzCanvasObject, pzPopupUploadImages: pzPopupUploadImages, pzPopupUploadImageProperties: pzPopupUploadImageProperties }, function () {
                                Promise.resolve(1);
                            });
                        }
                    });
                } else {
                    var _isPZCanvasObjToBeUpdated = false;
                    var _repeatData2 = {};
                    if (popupApplied2DData.repeatData) {
                        _repeatData2 = popupApplied2DData.repeatData['2d-customization-popup-repeat'];
                    }
                    var _ImagePartData = {};
                    var _RemoveImagePartData = {};
                    var _uploadedImages = Object.keys(_repeatData2).length > 0 && Object.keys(_repeatData2).map(async function (repeatDataViewType, viewIndex) {
                        if ("outside" == repeatDataViewType) {
                            var addedImages = _repeatData2[repeatDataViewType]['uploadData']['addImage'];

                            var uploadedImageData = {},
                                removeImageData = {};
                            uploadedImageData['addImage'] = {};

                            removeImageData['uploadData'] = {};
                            removeImageData['uploadData']['removeImage'] = [];
                            removeImageData['repeatSettings'] = {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: {}
                            };

                            var anotherViewType = "inside";

                            if (_repeatData2[repeatDataViewType]) {
                                var viewDataType = repeatDataViewType;
                                var existingImagesForAnotherView = _extends({}, _repeatData2[viewDataType]['uploadData']['addImage']);
                                if (Object.keys(existingImagesForAnotherView).length > 0) {
                                    var removeImages = [];
                                    removeImages = [].concat(_toConsumableArray(Object.keys(existingImagesForAnotherView)));
                                    removeImageData['uploadData']['removeImage'] = [].concat(_toConsumableArray(removeImages));
                                    _RemoveImagePartData[viewDataType] = _extends({}, removeImageData);
                                }
                            }

                            Object.keys(addedImages) && Object.keys(addedImages).map(async function (imageData, index) {
                                var fileEvent = addedImages[imageData]['image'];
                                var imageProperties = {};
                                var objKey = imageData;
                                //console.log("imageProperties ", imageProperties)
                                // console.log("objKey ", objKey)
                                if (objKey) {
                                    if (Object.keys(pzPopupUploadImageProperties).length > 0 && pzPopupUploadImageProperties[objKey]) {
                                        imageProperties = _extends({}, pzPopupUploadImageProperties[objKey]);
                                    } else {
                                        imageProperties = {
                                            left: 2048,
                                            top: 2048,
                                            scaleX: 1,
                                            scaleY: 1,
                                            originX: "center",
                                            originY: "center",
                                            applyFullScreen: false,
                                            maxHeight: _this.state.pzSizeProperties[_this.state.pzBaseType].maxHeight,
                                            layer: 2,
                                            selectable: true
                                        };
                                    }
                                    imageProperties.selectable = true;
                                    imageProperties.evented = true;

                                    var canvasDeleteImgKey = "FObject_option_background_" + objKey;

                                    // delete pzPopupUploadImages[objKey];
                                    _isPZCanvasObjToBeUpdated = true;
                                    if (canvasDeleteImgKey in pzCanvasObject) {
                                        delete pzCanvasObject[canvasDeleteImgKey];
                                        _isPZCanvasObjToBeUpdated = true;
                                    }
                                    var uploadImageCount = PromizeHome.popupUploadImageCount++;

                                    //uploadedImageData['addImage'][repeatDataViewType + '_' + (uploadImageCount)] = {
                                    uploadedImageData['addImage'][objKey] = {
                                        image: fileEvent,
                                        properties: imageProperties
                                    };

                                    pzPopupUploadImages[repeatDataViewType][objKey] = {
                                        customDataType: 'uploadData',
                                        addImageKey: '',
                                        key: objKey,
                                        file: fileEvent
                                    };
                                }
                                _ImagePartData[repeatDataViewType] = Object.assign({}, _ImagePartData[repeatDataViewType], _extends({}, uploadedImageData));
                                _ImagePartData['inside'] = Object.assign({}, {}, _extends({}, uploadedImageData));
                            });
                        } else {
                            var _addedImages2 = _repeatData2[repeatDataViewType]['uploadData']['addImage'];
                            if (Object.keys(_addedImages2).length > 0) {
                                if (_repeatData2[repeatDataViewType]) {
                                    var existingImages = _extends({}, _repeatData2[repeatDataViewType]['uploadData']['addImage']);
                                    if (Object.keys(existingImages).length > 0) {
                                        _RemoveImagePartData[repeatDataViewType] = {
                                            uploadData: {
                                                removeImage: [].concat(_toConsumableArray(Object.keys(existingImages)))
                                            },
                                            repeatSettings: {
                                                spacing: 0,
                                                groupSpacing: 0,
                                                objectSpacing: {}
                                            }
                                        };
                                    }
                                }
                            }

                            //let addedImages = repeatViewData['uploadData']['addImage'];
                        }
                        if (Object.keys(_repeatData2).length == viewIndex + 1) {
                            var customData1 = {
                                repeatData: {
                                    '2d-customization-popup-repeat': _RemoveImagePartData
                                },
                                uploadData: {
                                    '2d-customization-popup-repeat': _ImagePartData
                                }
                                //console.log("REPEAT upload ", customData1)
                            };_this.state.promizeTwoDObj.updateComponent(customData1);

                            _this.setState({ pzCanvasObject: pzCanvasObject, pzPopupUploadImages: pzPopupUploadImages, pzPopupUploadImageProperties: pzPopupUploadImageProperties }, function () {
                                Promise.resolve(1);
                            });
                        }
                    });
                }
            }
        }, _this.pzChangeUploadedImage = function () {
            var uploadType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'repeat';
            var _this$state7 = _this.state,
                pzCanvasObject = _this$state7.pzCanvasObject,
                pzPopupRepeatUploadImageKeys = _this$state7.pzPopupRepeatUploadImageKeys,
                pzPopupUploadImageProperties = _this$state7.pzPopupUploadImageProperties,
                pzPopupUploadImages = _this$state7.pzPopupUploadImages;

            var popupApplied2DData = _this.state.promizeTwoDObj.getCustomizationData();
            //console.log("popupApplied2DData ", popupApplied2DData)
            //console.log("uploadType " + uploadType)
            if (_this.state.pzPopupCopyToBoth) {
                _this.pzChangeUploadedImageForBothSides(popupApplied2DData, uploadType);
            } else {
                if (uploadType == 'repeat') {
                    var isPZCanvasObjToBeUpdated = false;
                    var repeatData = {};
                    if (popupApplied2DData.uploadData) {
                        repeatData = popupApplied2DData.uploadData['2d-customization-popup-repeat'];
                    }
                    var ImagePartData = {};
                    var RemoveImagePartData = {};
                    var uploadedImages = Object.keys(repeatData).length > 0 && Object.keys(repeatData).map(async function (repeatDataViewType, index) {
                        var repeatViewData = repeatData[repeatDataViewType];
                        if (repeatDataViewType == _this.state.pzPopupViewType) {

                            console.log("reoeate data ", repeatViewData['addImage']);
                            var addedImages = repeatViewData['addImage'];
                            var uploadedImageData = {},
                                removeImageData = {};
                            uploadedImageData['uploadData'] = {};
                            uploadedImageData['uploadData']['addImage'] = {};
                            uploadedImageData['repeatSettings'] = {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: {}
                            };
                            removeImageData['removeImage'] = [];
                            var firstUploadedImageLeft = 0;
                            var groupSpacing = 0;
                            addedImages = _this.sortObjects(addedImages, ['properties', 'left']);

                            Object.keys(addedImages) && Object.keys(addedImages).map(async function (imageData, index) {
                                var fileEvent = addedImages[imageData]['image'];
                                var imageProperties = _extends({}, addedImages[imageData]['properties']);
                                imageProperties.selectable = false;
                                imageProperties.evented = false;

                                if (index == 0) {
                                    firstUploadedImageLeft = imageProperties['left'] + imageProperties.objWidth / 2;
                                    imageProperties.left = 0;
                                } else {
                                    var tempLeft = imageProperties.left;
                                    var left = firstUploadedImageLeft + imageProperties.objWidth / 2;
                                    // if(left < 0) left = 0
                                    imageProperties.left -= left;
                                    firstUploadedImageLeft = tempLeft + imageProperties.objWidth / 2;
                                    groupSpacing = 0;
                                }

                                var objKey = imageData;
                                if (objKey) {
                                    pzPopupUploadImageProperties[objKey] = _extends({}, addedImages[imageData]['properties']);
                                    var canvasDeleteImgKey = "FObject_option_background_" + objKey;
                                    if (pzPopupUploadImages[repeatDataViewType] && pzPopupUploadImages[repeatDataViewType][objKey]) {
                                        delete pzPopupUploadImages[repeatDataViewType][objKey];
                                    }

                                    //delete pzPopupUploadImages[repeatDataViewType][objKey]

                                    isPZCanvasObjToBeUpdated = true;
                                    if (canvasDeleteImgKey in pzCanvasObject) {
                                        delete pzCanvasObject[canvasDeleteImgKey];
                                        isPZCanvasObjToBeUpdated = true;
                                    }
                                    removeImageData['removeImage'].push(objKey);
                                    //uploadedImageData['uploadData']['addImage'][repeatDataViewType + '_' + objKey + '_repeat'] = {
                                    uploadedImageData['uploadData']['addImage'][objKey] = {
                                        image: fileEvent,
                                        properties: imageProperties
                                    };

                                    pzPopupUploadImages[repeatDataViewType][objKey] = {
                                        customDataType: 'repeatData',
                                        addImageKey: 'uploadData',
                                        key: objKey,
                                        file: fileEvent
                                    };

                                    console.log("change from upload to repeat ==> pzPopupUploadImages ", pzPopupUploadImages);
                                }
                            });
                            uploadedImageData['repeatSettings'].groupSpacing = groupSpacing;
                            ImagePartData[repeatDataViewType] = Object.assign({}, ImagePartData[repeatDataViewType], _extends({}, uploadedImageData));
                            console.log("ImagePartData  ", ImagePartData);
                            RemoveImagePartData[repeatDataViewType] = Object.assign({}, RemoveImagePartData[repeatDataViewType], _extends({}, removeImageData));
                            console.log("RemoveImagePartData ", RemoveImagePartData);
                            if (isPZCanvasObjToBeUpdated) {

                                var customData1 = {
                                    uploadData: {
                                        '2d-customization-popup-repeat': RemoveImagePartData
                                    },
                                    repeatData: {
                                        '2d-customization-popup-repeat': ImagePartData
                                    }

                                };
                                console.log("REPEAT upload ", customData1);
                                _this.state.promizeTwoDObj.updateComponent(customData1);

                                _this.setState({ pzCanvasObject: pzCanvasObject, pzPopupUploadImages: pzPopupUploadImages, pzPopupUploadImageProperties: pzPopupUploadImageProperties }, function () {
                                    Promise.resolve(1);
                                });
                            }
                        }
                    });
                } else {

                    var _isPZCanvasObjToBeUpdated2 = false;

                    console.log("popupApplied2DData ", popupApplied2DData);
                    var _repeatData3 = {};
                    if (popupApplied2DData.repeatData) {
                        _repeatData3 = popupApplied2DData.repeatData['2d-customization-popup-repeat'];
                    }

                    var _ImagePartData2 = {},
                        _RemoveImagePartData2 = {};

                    var _uploadedImages2 = Object.keys(_repeatData3).length > 0 && Object.keys(_repeatData3).map(async function (repeatDataViewType, index) {
                        console.log("inside map");
                        var repeatViewData = _repeatData3[repeatDataViewType];
                        console.log("repeatViewData ", repeatViewData);
                        if (repeatDataViewType == _this.state.pzPopupViewType) {

                            console.log("reoeate data ", repeatViewData['uploadData']['addImage']);

                            // let addedImages = Object.values(repeatViewData['uploadData']['addImage']);
                            var addedImages = repeatViewData['uploadData']['addImage'];
                            var uploadedImageData = {},
                                removeImageData = {};
                            uploadedImageData['addImage'] = {};

                            removeImageData['uploadData'] = {};
                            removeImageData['uploadData']['removeImage'] = [];
                            removeImageData['repeatSettings'] = {
                                spacing: 0,
                                groupSpacing: 0,
                                objectSpacing: {}
                            };

                            Object.keys(addedImages) && Object.keys(addedImages).map(async function (imageData, index) {
                                var fileEvent = addedImages[imageData]['image'];
                                var imageProperties = {};
                                var objKey = imageData;
                                //console.log("imageProperties ", imageProperties)
                                //console.log("objKey ", objKey)
                                if (objKey) {
                                    if (Object.keys(pzPopupUploadImageProperties).length > 0 && pzPopupUploadImageProperties[objKey]) {
                                        imageProperties = _extends({}, pzPopupUploadImageProperties[objKey]);
                                    } else {
                                        imageProperties = {
                                            left: 2048,
                                            top: 2048,
                                            scaleX: 1,
                                            scaleY: 1,
                                            originX: "center",
                                            originY: "center",
                                            applyFullScreen: false,
                                            maxHeight: _this.state.pzSizeProperties[_this.state.pzBaseType].maxHeight,
                                            layer: 2,
                                            selectable: true,
                                            evented: true
                                        };
                                    }
                                    imageProperties.seletable = true;
                                    imageProperties.evented = true;

                                    var canvasDeleteImgKey = "FObject_option_background_" + objKey;

                                    if (pzPopupUploadImages[repeatDataViewType] && pzPopupUploadImages[repeatDataViewType][objKey]) {
                                        delete pzPopupUploadImages[repeatDataViewType][objKey];
                                    }
                                    _isPZCanvasObjToBeUpdated2 = true;
                                    if (canvasDeleteImgKey in pzCanvasObject) {
                                        delete pzCanvasObject[canvasDeleteImgKey];
                                        _isPZCanvasObjToBeUpdated2 = true;
                                    }
                                    removeImageData['uploadData']['removeImage'].push(objKey);
                                    var uploadImageCount = PromizeHome.popupUploadImageCount++;

                                    //uploadedImageData['addImage'][repeatDataViewType + '_' + (uploadImageCount)] = {
                                    uploadedImageData['addImage'][objKey] = {
                                        image: fileEvent,
                                        properties: _extends({}, imageProperties)
                                    };
                                    pzPopupUploadImages[repeatDataViewType][objKey] = {
                                        customDataType: 'uploadData',
                                        addImageKey: '',
                                        key: objKey,
                                        file: fileEvent
                                    };
                                }
                                _ImagePartData2[repeatDataViewType] = Object.assign({}, _ImagePartData2[repeatDataViewType], _extends({}, uploadedImageData));
                                //console.log("ImagePartData  ", ImagePartData);

                                _RemoveImagePartData2[repeatDataViewType] = Object.assign({}, _RemoveImagePartData2[repeatDataViewType], _extends({}, removeImageData));
                                //console.log("RemoveImagePartData ", RemoveImagePartData)
                            });
                        }
                    });
                    if (_isPZCanvasObjToBeUpdated2) {
                        var customData1 = {
                            repeatData: {
                                '2d-customization-popup-repeat': _RemoveImagePartData2
                            },
                            uploadData: {
                                '2d-customization-popup-repeat': _ImagePartData2
                            }
                        };
                        console.log("single upload ", customData1);
                        _this.state.promizeTwoDObj.updateComponent(customData1);

                        _this.setState({ pzCanvasObject: pzCanvasObject, pzPopupUploadImages: pzPopupUploadImages }, function () {
                            Promise.resolve(1);
                        });
                    }
                }
            }
        }, _this.pzPopupUpdateCanvasObj = function (name, uploadedImages) {
            var _this$state8 = _this.state,
                pzCanvasObject = _this$state8.pzCanvasObject,
                pzPopupUploadImages = _this$state8.pzPopupUploadImages;

            pzPopupUploadImages[name] = uploadedImages;
            pzCanvasObject[name].src = uploadedImages;
            _this.setState({ pzCanvasObject: pzCanvasObject, pzPopupUploadImages: pzPopupUploadImages });
        }, _this.pzPopupGetUploadedImagesKeys = function () {
            //let pzPopupAppliedData = (this.state.promizeTwoDObj) ? this.state.promizeTwoDObj.getCustomizationData() : null;
            var pzPopupAppliedData = _this.state.pzPopupAppliedData;

            if (pzPopupAppliedData && Object.keys(pzPopupAppliedData).length > 0) {

                var popupRepeatData = 'repeatData' in pzPopupAppliedData ? pzPopupAppliedData['repeatData'] : {};
                var popupUploadData = 'uploadData' in pzPopupAppliedData ? pzPopupAppliedData['uploadData'] : {};
                var popupRepeatDataImageKeys = {};
                var popupUploadedDataImageKeys = {};

                return new Promise(async function (resolve) {
                    if (Object.keys(popupRepeatData).length > 0) {
                        //console.log("length")
                        popupRepeatDataImageKeys = Object.keys(popupRepeatData['2d-customization-popup-repeat']).map(async function (repeatViewType, index) {

                            var addedImages = popupRepeatData['2d-customization-popup-repeat'][repeatViewType]['uploadData']['addImage'];

                            if (Object.keys(addedImages).length > 0) {

                                return {
                                    repeatViewType: _extends({}, addedImages)
                                };
                            }
                        });
                    }
                    if (Object.keys(popupUploadData).length > 0) {
                        //console.log("length")
                        popupUploadedDataImageKeys = Object.keys(popupUploadData['2d-customization-popup-repeat']).map(async function (repeatViewType, index) {

                            var addedImages = popupUploadData['2d-customization-popup-repeat'][repeatViewType]['addImage'];

                            if (Object.keys(addedImages).length > 0) {
                                return {
                                    repeatViewType: _extends({}, addedImages)
                                };
                            }
                        });
                    }

                    resolve(_extends({}, popupRepeatDataImageKeys, popupUploadedDataImageKeys));
                });
            }
        }, _this.pzRemoveUploadedImageData = function (viewType, imgKey) {
            var uploadType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'repeat';

            console.log("%c POPUP REMOVE ", 'background-color:green;color:white');
            // const viewType = this.state.pzPopupViewType;
            var ImagePartData = {};
            var uploadedImageData = {};
            var customData = {};
            uploadedImageData['removeImage'] = [];
            uploadedImageData['removeImage'].push(imgKey);

            if (uploadType == 'repeat') {
                ImagePartData[viewType] = {
                    uploadData: uploadedImageData,
                    repeatSettings: {
                        objectSpacing: 0
                    }
                };
                customData = {
                    repeatData: _defineProperty({}, '2d-customization-popup-repeat', ImagePartData)
                };
            } else {
                ImagePartData[viewType] = uploadedImageData;
                customData = {
                    uploadData: _defineProperty({}, '2d-customization-popup-repeat', ImagePartData)
                };
            }

            console.log("customData ::", customData);
            return customData;
        }, _this.pzPopupCopyProperties = function (pzPopupAppliedData) {
            console.log("pzPopupAppliedData ", pzPopupAppliedData);
            var pzPopupUploadImages = _this.state.pzPopupUploadImages;
            var pzPopupViewBasedUploadType = _this.state.pzPopupViewBasedUploadType;
            var pzPopupViewType = _this.state.pzPopupViewType;
            if (pzPopupAppliedData && Object.keys(pzPopupAppliedData).length > 0) {
                var popupUploadType = _this.state.pzPopupRepeat;
                var popupData = {},
                    popupUploadData = {};

                //if (this.state.pzPopupRepeat) {
                if (pzPopupViewBasedUploadType[pzPopupViewType] == "repeat") {
                    popupData = 'repeatData' in pzPopupAppliedData ? pzPopupAppliedData['repeatData'] : {};
                } else {
                    popupUploadData = 'uploadData' in pzPopupAppliedData ? pzPopupAppliedData['uploadData'] : {};
                }
                return new Promise(async function (resolve) {
                    if (pzPopupViewBasedUploadType[pzPopupViewType] == "repeat" && Object.keys(popupData).length > 0) {

                        //
                        Object.keys(popupData['2d-customization-popup-repeat']).map(async function (repeatViewType, index) {
                            if ("outside" == repeatViewType) {
                                var addedImages = {};
                                addedImages = popupData['2d-customization-popup-repeat'][repeatViewType]['uploadData']['addImage'];

                                if (Object.keys(addedImages).length > 0) {
                                    var anotherViewType = "inside";
                                    var removeImages = [];
                                    var normalUploadRemoveImage = [];

                                    if ('uploadData' in pzPopupAppliedData && pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][anotherViewType] && pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][anotherViewType]['addImage']) {

                                        var normalUploadExistingImagesForAnotherView = _extends({}, pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][anotherViewType]['addImage']);

                                        if (Object.keys(normalUploadExistingImagesForAnotherView).length > 0) {
                                            normalUploadRemoveImage = [].concat(_toConsumableArray(Object.keys(normalUploadExistingImagesForAnotherView)));

                                            pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][anotherViewType] = {
                                                removeImage: [].concat(_toConsumableArray(normalUploadRemoveImage))
                                            };
                                        }
                                    }

                                    if (pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][anotherViewType]) {
                                        var existingImagesForAnotherView = _extends({}, pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][anotherViewType]['uploadData']['addImage']);

                                        if (Object.keys(existingImagesForAnotherView).length > 0) {
                                            removeImages = [].concat(_toConsumableArray(Object.keys(existingImagesForAnotherView)));
                                        }
                                    }
                                    pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][anotherViewType] = {
                                        uploadData: {
                                            removeImage: [].concat(_toConsumableArray(removeImages)),
                                            addImage: _extends({}, pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][repeatViewType]['uploadData']['addImage'])
                                        },
                                        repeatSettings: {
                                            spacing: 0,
                                            groupSpacing: 0,
                                            objectSpacing: {}
                                        }
                                    };
                                    //console.log(" karthavey ", pzPopupAppliedData)
                                }
                            }
                            //}
                        });
                    }
                    if (pzPopupViewBasedUploadType[pzPopupViewType] != "repeat" && Object.keys(popupUploadData).length > 0) {
                        //delete pzPopupUploadImages['outside']
                        // console.log("length uploadimage")
                        Object.keys(popupUploadData['2d-customization-popup-repeat']).map(async function (repeatViewType, index) {

                            if ("outside" == repeatViewType) {
                                var addedImages = popupUploadData['2d-customization-popup-repeat'][repeatViewType]['addImage'];

                                if (Object.keys(addedImages).length > 0) {
                                    var anotherViewType = "inside";
                                    var removeImages = [];
                                    var repeatUploadRemoveImage = [];

                                    if ('repeatData' in pzPopupAppliedData && pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][anotherViewType] && pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][anotherViewType]['uploadData']['addImage']) {

                                        var repeatUploadExistingImagesForAnotherView = _extends({}, pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][anotherViewType]['uploadData']['addImage']);

                                        if (Object.keys(repeatUploadExistingImagesForAnotherView).length > 0) {
                                            repeatUploadRemoveImage = [].concat(_toConsumableArray(Object.keys(repeatUploadExistingImagesForAnotherView)));

                                            pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][anotherViewType] = {
                                                uploadData: {
                                                    removeImage: [].concat(_toConsumableArray(repeatUploadRemoveImage))
                                                }
                                            };
                                        }
                                    }

                                    if (pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][anotherViewType]) {
                                        var existingImagesForAnotherView = _extends({}, pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][anotherViewType]['addImage']);

                                        if (Object.keys(existingImagesForAnotherView).length > 0) {
                                            removeImages = [].concat(_toConsumableArray(Object.keys(existingImagesForAnotherView)));
                                        }
                                    }

                                    pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][anotherViewType] = {
                                        removeImage: [].concat(_toConsumableArray(removeImages)),
                                        addImage: _extends({}, pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][repeatViewType]['addImage'])
                                    };
                                    //console.log(" karthavey ", pzPopupAppliedData);
                                }
                            }
                        });
                    }

                    resolve(_extends({}, pzPopupAppliedData));
                });
            }
        }, _this.pzPopupCopyBoth = function (event) {

            /*   if (!this.state.pzPopupCopyToBoth) {
                  this.state.promizeTwoDObj.cleanUpView('inside');
              } */

            var pzPopupUploadImages = _this.state.pzPopupUploadImages;
            var pzPopupViewBasedUploadType = _this.state.pzPopupViewBasedUploadType;
            pzPopupUploadImages['inside'] = JSON.parse(JSON.stringify(pzPopupUploadImages['outside']));
            pzPopupViewBasedUploadType["inside"] = JSON.parse(JSON.stringify(pzPopupViewBasedUploadType["outside"]));

            _this.setState({ pzPopupCopyToBoth: !_this.state.pzPopupCopyToBoth, pzPopupUploadImages: pzPopupUploadImages, pzPopupViewBasedUploadType: pzPopupViewBasedUploadType }, async function () {
                var popupApplied2DData = _this.state.promizeTwoDObj.getCustomizationData();
                if (Object.keys(popupApplied2DData).length > 0) {
                    _this.pzPopupCopyProperties(popupApplied2DData).then(function (copyAppliedData) {
                        _this.state.promizeTwoDObj.updateComponent(copyAppliedData);
                    });
                }
            });
        }, _this.pzPopupSwitchViewType = function (event, viewType) {
            _this.setState({ pzPopupViewType: viewType }, function () {
                var updateViewData = {
                    selectView: viewType
                };
                _this.state.promizeTwoDObj.updateView(updateViewData);
            });
        }, _this.pzUploadImageValidation = function (event, imageDetail) {

            var files = event.target.files[0];
            var pzAttrImageValue = imageDetail.promize_attribute_image_value;

            var pzMaxUploadSize = pzAttrImageValue.max_upload_size ? pzAttrImageValue.max_upload_size : 1;
            var pzMinUploadSize = pzAttrImageValue.min_upload_size ? pzAttrImageValue.min_upload_size : 0;
            var imgStatus = true;
            var imgErrorMsg = '';
            var imgStatusArray = [];
            var fileExtension = files.name.split('.').pop();
            //var allowedFileExtensionArray = pzAttrImageValue.image_format.split(',');
            var allowedFileExtensionArray = pzAttrImageValue.image_format.split(/[\s, ]+/);
            var fileExtensionArray = allowedFileExtensionArray.map(function (item) {
                return item.toLowerCase();
            });
            fileExtension = fileExtension.toLowerCase();

            if (fileExtensionArray.length > 0 && !fileExtensionArray.includes(fileExtension)) {
                imgStatus = false;
                imgErrorMsg = 'File extension is Invalid!';
            }
            var fileSize = files.size / (2048 * 2048);
            if (fileSize > pzMaxUploadSize || fileSize < pzMinUploadSize) {
                imgStatus = false;
                imgErrorMsg = 'Uploaded Image file size should be between';
                if (pzMinUploadSize == 0) {
                    imgErrorMsg += ' 1 KB';
                } else {
                    imgErrorMsg += ' ' + pzMinUploadSize + ' MB';
                }
                imgErrorMsg += ' and ' + pzMaxUploadSize + ' MB';
            }
            var imageArray = _this.state.pzActiveImages[imageDetail.promize_tab_image_attribute_values_id];
            if (imageDetail.max_image_limit != null && imageArray && imageDetail.max_image_limit < imageArray.length + 1) {
                imgStatus = false;
                imgErrorMsg = 'Sorry! you can upload maximum of ' + imageDetail.max_image_limit + ' file(s)';
            }

            imgStatusArray['imgStatus'] = imgStatus;
            imgStatusArray['imgErrorMsg'] = imgErrorMsg;
            return imgStatusArray;
        }, _this.pzSaveUploadedImage = async function (repeatData, viewType) {
            var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'repeat';

            var uploadedImages = Object.keys(repeatData).length > 0 && Object.keys(repeatData).map(async function (objKey, index) {

                var fileEvent = repeatData[objKey]['image'];

                var width = 1000,
                    height = 1000;

                var currUploadedImg = new Image();
                currUploadedImg.src = window.URL.createObjectURL(fileEvent);
                currUploadedImg.onload = function () {

                    width = currUploadedImg.width < width ? currUploadedImg.width : width;
                    height = currUploadedImg.height < height ? currUploadedImg.height : height;
                };
                //}


                var formData = new FormData();
                formData.append("file", fileEvent);
                formData.append("name", 'uploadimage');
                var res = await fetch(_this.state.pzApiUrl + "uploadImageWithRemoveWhite/" + parseInt(width) + '/' + parseInt(height), {
                    method: "POST",
                    body: formData
                });
                var response = await res.json();
                var resizedImage = _this.state.pzImgUrl + response.resized_image.replace(_this.state.pzReplaceImg, '');
                var originalImageSrc = response.coverted_image ? _this.state.pzImgUrl + response.coverted_image.replace(_this.state.pzReplaceImg, '') : '';
                var name = "FObject_option_background_" + viewType + "_" + objKey;
                var newObj = _defineProperty({}, name, {
                    src: resizedImage,
                    viewType: viewType,
                    uploadType: type,
                    addImageKey: objKey,
                    canvasObjKey: name,
                    originalImageSrc: originalImageSrc
                });
                console.log("newObj  ", newObj);
                return newObj;
            });
            return await Promise.all(uploadedImages);
        }, _this.pzWriteCanvasObject = function () {
            var popupApplied2DData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            console.log("popupApplied2DData ", popupApplied2DData);
            var _this$state9 = _this.state,
                pzCanvasObject = _this$state9.pzCanvasObject,
                pzPopupAppliedData = _this$state9.pzPopupAppliedData,
                pzPopupUploadImages = _this$state9.pzPopupUploadImages,
                pzPopupCanvasUploadImages = _this$state9.pzPopupCanvasUploadImages;

            if (popupApplied2DData) pzPopupAppliedData = _extends({}, popupApplied2DData);

            Object.keys(pzCanvasObject).map(function (objKey, objIdx) {
                if (objKey.includes('background')) {
                    //objectSpacing[objKey] = parseInt(pzCanvasObject[objKey]['objectSpacing'])
                    delete pzCanvasObject[objKey];
                }
            });

            if (Object.keys(popupApplied2DData).length > 0) {

                if ('repeatData' in popupApplied2DData) {
                    var repeatData = popupApplied2DData.repeatData['2d-customization-popup-repeat'];
                    console.log(repeatData, "repeatData");

                    var uploadedImages = Object.keys(repeatData).length > 0 && Object.keys(repeatData).map(async function (repeatDataViewType, index) {

                        var repeatViewData = repeatData[repeatDataViewType];
                        var addedImages = {};
                        addedImages = repeatViewData['uploadData']['addImage'];

                        if (addedImages && Object.keys(addedImages).length > 0) {

                            _this.pzSaveUploadedImage(addedImages, repeatDataViewType, 'repeat').then(function (newUploadedImages) {
                                var userUploadedImages = {};
                                userUploadedImages = Object.assign.apply(Object, [{}].concat(_toConsumableArray(userUploadedImages), _toConsumableArray(newUploadedImages)));

                                pzPopupCanvasUploadImages = Object.assign.apply(Object, [{}].concat(_toConsumableArray(pzPopupCanvasUploadImages), _toConsumableArray(newUploadedImages)));

                                userUploadedImages && Object.keys(userUploadedImages).length > 0 && Object.keys(userUploadedImages).map(function (imageKey, imageIdx) {

                                    pzCanvasObject[imageKey] = {
                                        "type": "image",
                                        "name": imageKey,
                                        "src": userUploadedImages[imageKey].src,
                                        "layerno": 1,
                                        "width": 1,
                                        "height": 1,
                                        "left": 1,
                                        "top": 1,
                                        "scaleX": 1,
                                        "scaleY": 1,
                                        "angle": 1,
                                        //"filters": pzColorFilter,
                                        "tabId": 1, //pzObjectParams.promize_tab_id,
                                        "tabAttrId": 1, //pzObjectParams.promize_tab_attribute_id,
                                        "tabAttrValueId": 1, //pzObjectParams.promize_tab_attribute_values_id,
                                        "selectable": false,
                                        "hasControls": false,
                                        "hasBorders": false,
                                        "opacity": 1,
                                        "crossOrigin": "anonymous",
                                        "value": '', //pzObjectParams.optionValue,
                                        "customType": 'uploadimage',
                                        "option_name": '', //(pzObjectParams.promize_attribute_value.option_name) ? pzObjectParams.promize_attribute_value.option_name : '',
                                        "option_price": '', //pzObjectParams.promize_attribute_value.option_price,
                                        //"tab_name": 'Background' + ((imageKey).includes('outside') ? ' Front Image' : ' Back Image'),
                                        //"attribute_name": 'Background' + ((imageKey).includes('outside') ? ' Front Image' : ' Back Image'),
                                        "tab_name": 'Background',
                                        "attribute_name": 'Background',
                                        partNames: [userUploadedImages[imageKey].viewType],
                                        'sourceOrigin': '2d_customization_popup_repeat',
                                        originalImageSrc: userUploadedImages[imageKey].originalImageSrc ? userUploadedImages[imageKey].originalImageSrc : userUploadedImages[imageKey].src
                                    };

                                    if (imageIdx == Object.keys(userUploadedImages).length - 1) {
                                        console.log("its coming here pzPopupCanvasUploadImages ", pzPopupCanvasUploadImages);
                                        _this.setState({ pzCanvasObject: pzCanvasObject, pzPopupAppliedData: pzPopupAppliedData, pzPopupCanvasUploadImages: pzPopupCanvasUploadImages });
                                    }
                                });
                            });
                        }
                    });
                }
                if ('uploadData' in popupApplied2DData) {
                    var _repeatData5 = popupApplied2DData.uploadData['2d-customization-popup-repeat'];
                    console.log(_repeatData5, "repeatData");

                    // await Promise.all(uploadedImages).then(function (userUploadedImages) {

                    var _uploadedImages3 = Object.keys(_repeatData5).length > 0 && Object.keys(_repeatData5).map(async function (repeatDataViewType, index) {

                        var repeatViewData = _repeatData5[repeatDataViewType];

                        var addedImages = {};
                        addedImages = repeatViewData['addImage'];
                        if (addedImages && Object.keys(addedImages).length > 0) {
                            _this.pzSaveUploadedImage(addedImages, repeatDataViewType, 'normal').then(function (newUploadedImages) {

                                pzPopupCanvasUploadImages = Object.assign.apply(Object, [{}].concat(_toConsumableArray(pzPopupCanvasUploadImages), _toConsumableArray(newUploadedImages)));

                                var userUploadedImages = {};
                                userUploadedImages = Object.assign.apply(Object, [{}].concat(_toConsumableArray(userUploadedImages), _toConsumableArray(newUploadedImages)));

                                userUploadedImages && Object.keys(userUploadedImages).length > 0 && Object.keys(userUploadedImages).map(function (imageKey, imageIdx) {
                                    console.log(" uploSWS IMAGES ", userUploadedImages[imageKey]);
                                    pzCanvasObject[imageKey] = {
                                        "type": "image",
                                        "name": imageKey,
                                        "src": userUploadedImages[imageKey].src,
                                        "layerno": 1,
                                        "width": 1,
                                        "height": 1,
                                        "left": 1,
                                        "top": 1,
                                        "scaleX": 1,
                                        "scaleY": 1,
                                        "angle": 1,
                                        //"filters": pzColorFilter,
                                        "tabId": 1, //pzObjectParams.promize_tab_id,
                                        "tabAttrId": 1, //pzObjectParams.promize_tab_attribute_id,
                                        "tabAttrValueId": 1, //pzObjectParams.promize_tab_attribute_values_id,
                                        "selectable": false,
                                        "hasControls": false,
                                        "hasBorders": false,
                                        "opacity": 1,
                                        "crossOrigin": "anonymous",
                                        "value": '', //pzObjectParams.optionValue,
                                        "customType": 'uploadimage',
                                        "option_name": '', //(pzObjectParams.promize_attribute_value.option_name) ? pzObjectParams.promize_attribute_value.option_name : '',
                                        "option_price": '', //pzObjectParams.promize_attribute_value.option_price,
                                        //"tab_name": 'Background' + ((imageKey).includes('outside') ? ' Front Image' : ' Back Image'),
                                        //"attribute_name": 'Background' + ((imageKey).includes('outside') ? ' Front Image' : ' Back Image'),
                                        "tab_name": 'Background',
                                        "attribute_name": 'Background',
                                        partNames: [userUploadedImages[imageKey].viewType],
                                        'sourceOrigin': '2d_customization_popup_repeat',
                                        originalImageSrc: userUploadedImages[imageKey].originalImageSrc ? userUploadedImages[imageKey].originalImageSrc : userUploadedImages[imageKey].src
                                    };

                                    if (imageIdx == Object.keys(userUploadedImages).length - 1) {
                                        console.log("its coming here pzPopupCanvasUploadImages ", pzPopupCanvasUploadImages);
                                        _this.setState({ pzCanvasObject: pzCanvasObject, pzPopupAppliedData: pzPopupAppliedData, pzPopupCanvasUploadImages: pzPopupCanvasUploadImages });
                                    }
                                });
                            });
                        }
                    });
                }
            }
        }, _this.pzPopupApplyToLanyard = function () {
            var pzCanvasObject = _this.state.pzCanvasObject;
            //let popupApplied2DData = this.state.promizeTwoDObj.applyCustomization(true);

            _this.state.promizeTwoDObj.applyCustomization().then(function (popupApplied2DData) {
                var pzPopupAppliedData = Object.assign({}, {}, _extends({}, popupApplied2DData));
                _this.setState({ pzPopupAppliedData: pzPopupAppliedData }, function () {
                    _this.pzWriteCanvasObject(popupApplied2DData);
                    _this.pzClosePopup(0);
                });
            });
            //this.pzClosePopup(0);
        }, _this.pzPopupRemoveUploadedImage = function (viewType, imgKey) {
            var uploadType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'repeat';

            console.log("%c POPUP REMOVE ", 'background-color:green;color:white');
            // const viewType = this.state.pzPopupViewType;
            var ImagePartData = {};
            var uploadedImageData = {};
            var customData = {};
            uploadedImageData['removeImage'] = [];
            uploadedImageData['removeImage'].push(imgKey);

            if (uploadType == 'repeat') {
                ImagePartData[viewType] = {
                    upload: uploadedImageData,
                    repeatSettings: {
                        objectSpacing: 0
                    }
                };
                customData = {
                    repeatData: _defineProperty({}, '2d-customization-popup-repeat', ImagePartData)
                };
            } else {
                ImagePartData[viewType] = uploadedImageData;
                customData = {
                    uploadData: _defineProperty({}, '2d-customization-popup-repeat', ImagePartData)
                };
            }
            console.log("customData ::", customData);
            return customData;
        }, _this.pzClosePopup = async function () {
            var callCancelCustomization = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            _this.setState({ popup: false });
            //this.state.promizeTwoDObj.applyCustomization(false)
            if (callCancelCustomization) {
                _this.state.promizeTwoDObj.cancelCustomization();
            } else {
                var _this$state10 = _this.state,
                    pzCanvasObject = _this$state10.pzCanvasObject,
                    pzActiveOptions = _this$state10.pzActiveOptions,
                    pzPopupBackgroundAttr = _this$state10.pzPopupBackgroundAttr;


                _this.state.promizeThreeDObj.cleanUp(['4d-customization-texture-repeat']);

                if (pzPopupBackgroundAttr.tabId) {
                    delete pzActiveOptions[pzPopupBackgroundAttr.tabId];
                }
                _this.setState({ pzActiveOptions: pzActiveOptions }, function () {
                    _this.pzApplyRules();
                });

                //pzPopupAppliedData = {};
                var componentData = {
                    name: "tag_component",
                    component: {
                        name: _this.state.pzBaseType ? _this.state.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: {
                                colorData: {
                                    inside: '#ffffff',
                                    outside: '#ffffff'
                                }
                            }
                        }
                    }
                };
                await _this.state.promizeThreeDObj.updateComponent(componentData);
            }
        }, _this.panSlider = function (e) {
            var sliderValue = e.target.value;
            var promizeThreeDObj = _this.state.promizeThreeDObj;

            _this.setState({ pzPanSlider: sliderValue }, function () {
                var value = parseInt(sliderValue);
                var sceneData = {};
                if (value > 0 && previousValue > value) {
                    var panValue = previousValue - value;
                    sceneData = {
                        view: {
                            panDown: -panValue
                        }
                    };
                } else if (value > 0 && previousValue < value) {
                    var _panValue = value - previousValue;
                    sceneData = {
                        view: {
                            panUp: _panValue
                        }
                    };
                } else if (value < 0 && previousValue > value) {
                    var _panValue2 = previousValue < 0 ? Math.abs(Math.abs(previousValue) - Math.abs(value)) : previousValue - value;
                    sceneData = {
                        view: {
                            panDown: -_panValue2
                        }
                    };
                } else if (value < 0 && previousValue < value) {
                    var _panValue3 = Math.abs(Math.abs(value) - Math.abs(previousValue));
                    sceneData = {
                        view: {
                            panUp: _panValue3
                        }
                    };
                } else if (value == 0 && previousValue > value) {
                    var _panValue4 = previousValue;
                    sceneData = {
                        view: {
                            panDown: -_panValue4
                        }
                    };
                } else if (value == 0 && previousValue < value) {
                    var _panValue5 = Math.abs(previousValue);
                    sceneData = {
                        view: {
                            panUp: _panValue5
                        }
                    };
                } else {
                    sceneData = {
                        view: {
                            panDown: 0
                        }
                    };
                }
                previousValue = value;
                promizeThreeDObj.updateView(sceneData);
            });
        }, _this.pzChangePopupProperitiesBySize = function () {
            var pzBaseType = _this.state.pzBaseType;
            var maxHeight = _this.state.pzSizeProperties[pzBaseType].maxHeight;
            var pzPopupAppliedData = _this.state.pzPopupAppliedData;
            if (pzPopupAppliedData && Object.keys(pzPopupAppliedData).length > 0) {

                var popupRepeatData = 'repeatData' in pzPopupAppliedData ? pzPopupAppliedData['repeatData'] : {};
                var popupUploadData = 'uploadData' in pzPopupAppliedData ? pzPopupAppliedData['uploadData'] : {};
                return new Promise(async function (resolve) {
                    if (Object.keys(popupRepeatData).length > 0) {
                        //console.log("length")
                        Object.keys(popupRepeatData['2d-customization-popup-repeat']).map(async function (repeatViewType, index) {

                            var addedImages = popupRepeatData['2d-customization-popup-repeat'][repeatViewType]['uploadData']['addImage'];

                            Object.keys(addedImages).map(async function (imageData, index) {
                                var imageProperties = addedImages[imageData].properties;
                                if (imageProperties) {
                                    if (imageProperties.maxHeight) {
                                        //let scaleY = imageProperties['scaleY']
                                        //console.log("length")
                                        pzPopupAppliedData.repeatData['2d-customization-popup-repeat'][repeatViewType]['uploadData']['addImage'][imageData].properties['maxHeight'] = maxHeight;
                                    }
                                }
                            });
                        });
                    }
                    if (Object.keys(popupUploadData).length > 0) {
                        //console.log("length")
                        Object.keys(popupUploadData['2d-customization-popup-repeat']).map(async function (repeatViewType, index) {

                            var addedImages = popupUploadData['2d-customization-popup-repeat'][repeatViewType]['addImage'];

                            Object.keys(addedImages).map(async function (imageData, index) {
                                var imageProperties = addedImages[imageData].properties;
                                if (imageProperties) {
                                    if (imageProperties.maxHeight) {
                                        //let scaleY = imageProperties['scaleY']
                                        pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][repeatViewType]['addImage'][imageData].properties['maxHeight'] = maxHeight;
                                        pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][repeatViewType]['addImage'][imageData].properties['selected'] = false;
                                        pzPopupAppliedData.uploadData['2d-customization-popup-repeat'][repeatViewType]['addImage'][imageData].properties['evented'] = false;
                                    }
                                }
                            });
                        });
                    }

                    resolve(_extends({}, pzPopupAppliedData));
                });
            }
        }, _this.apply2dObjects = function () {
            var _this$state11 = _this.state,
                promizeThreeDObj = _this$state11.promizeThreeDObj,
                pzCanvasObject = _this$state11.pzCanvasObject,
                pzCopyObjectsKeys = _this$state11.pzCopyObjectsKeys,
                pzPopupAppliedData = _this$state11.pzPopupAppliedData;

            console.log("apply2dObjects ******");

            var appliedBackgroundData = 0;

            for (var objKey in pzCanvasObject) {
                if (objKey.includes('background')) {
                    console.log("isnide for background");
                    appliedBackgroundData = 1;
                    break;
                }
            }

            console.log("appliedBackgroundData ", appliedBackgroundData);

            if (pzPopupAppliedData && Object.keys(pzPopupAppliedData).length > 0 && appliedBackgroundData == 1) {

                _this.pzChangePopupProperitiesBySize().then(async function (currApppliedData) {
                    console.log("currApppliedData ", currApppliedData);

                    var repeatData = '';
                    var uploadData = '';
                    if (currApppliedData.repeatData) {
                        repeatData = {
                            '2d-customization-popup-repeat': currApppliedData.repeatData['2d-customization-popup-repeat']
                        };
                    }
                    if (currApppliedData.uploadData) {
                        uploadData = {
                            '2d-customization-popup-repeat': currApppliedData.uploadData['2d-customization-popup-repeat']

                        };
                    }

                    var popupComponentData = {
                        name: 'tag_component',
                        component: {
                            name: _this.state.pzBaseType ? _this.state.pzBaseType : '3/4',
                            component: {
                                name: 'tag',
                                customizationData: {
                                    repeatData: repeatData,
                                    uploadData: uploadData
                                }
                            }
                        }
                    };
                    console.log("coming here*****", popupComponentData);
                    //if ((pzCopyObjectsKeys.length) <= 0) {
                    var popupData1 = await promizeThreeDObj.getComponentData(popupComponentData, 'customizationData');
                    promizeThreeDObj.updateComponent(popupComponentData);
                });
            }

            pzCopyObjectsKeys.length > 0 && pzCopyObjectsKeys.map(async function (objKey, index) {
                var repeatSettings = {
                    left: 40,
                    top: 2048,
                    //objectSpacing: 20,
                    spacing: false
                };

                var repeatData = {};

                if (pzCanvasObject && pzCanvasObject[objKey]) {
                    var currObject = pzCanvasObject[objKey];

                    console.log("currObject ", currObject);

                    var partNames = currObject['partNames'];

                    if (objKey.includes('_text_')) {
                        var textPartData = {};
                        repeatSettings.objectSpacing = pzCanvasObject['textSpacing'] ? parseInt(pzCanvasObject['textSpacing']) : 20;

                        partNames && Object.values(partNames).map(function (partName, idx) {
                            var textObj = {
                                'addText': _defineProperty({}, currObject.tabAttrId, {
                                    text: currObject['text'],
                                    properties: {
                                        top: 2048,
                                        left: 0,
                                        fontSize: currObject['fontSize'],
                                        fill: currObject['fill'],
                                        textAlign: 'left',
                                        fontFamily: currObject['fontFamily'],
                                        fontWeight: currObject['fontWeight'],
                                        fontStyle: currObject['fontStyle'],
                                        underline: currObject['underline'],
                                        scaleX: 1,
                                        scaleY: 1,
                                        selectable: false,
                                        evented: false,
                                        layer: 1
                                    }
                                })
                            };
                            textPartData[partName] = {
                                textData: textObj,
                                repeatSettings: {
                                    spacing: 0,
                                    groupSpacing: 0,
                                    objectSpacing: _defineProperty({}, currObject.tabAttrId, currObject['objectSpacing'])
                                }
                            };
                        });
                        var data3_8 = {
                            name: 'tag_component',
                            component: {
                                name: _this.state.pzBaseType ? _this.state.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        repeatData: {
                                            '3d-customization-normal-repeat': textPartData
                                        }
                                    }
                                }
                            }
                        };

                        console.log("data3_8 ", data3_8);
                        var customizationData = await promizeThreeDObj.getComponentData(data3_8, 'customizationData');
                        promizeThreeDObj.updateComponent(data3_8);
                    } else {
                        var ImagePartData = {};

                        var uploadedFile = currObject['fileEvent']; //event.target.files[0]
                        var imageInc = currObject['imageIndex'];
                        repeatSettings.objectSpacing = pzCanvasObject['imageSpacing'] ? parseInt(pzCanvasObject['imageSpacing']) : 20;

                        var addImages = {};

                        partNames && Object.values(partNames).map(function (partName, idx) {
                            //addImages[partName + '_' + imageInc] = {
                            addImages[currObject.name] = {

                                image: uploadedFile,
                                properties: {
                                    left: 0,
                                    top: 2048,
                                    scaleX: 1,
                                    scaleY: 1,
                                    applyFullScreen: false,
                                    maxWidth: 4096,
                                    maxHeight: _this.state.pzSizeProperties[_this.state.pzBaseType].maxHeight,
                                    selectable: false,
                                    lockMovement: true,
                                    evented: false,
                                    layer: 1
                                }
                            };

                            repeatData[partName] = {
                                uploadData: { 'addImage': addImages },
                                repeatSettings: {
                                    spacing: 0,
                                    groupSpacing: 0,
                                    objectSpacing: _defineProperty({}, currObject.name, currObject['objectSpacing'])
                                }
                                //repeatData[partName].repeatSettings.objectSpacing = parseInt(pzCanvasObject[objKey]['objectSpacing']);
                            };
                        });

                        var _data3_ = {
                            name: 'tag_component',
                            component: {
                                name: _this.state.pzBaseType ? _this.state.pzBaseType : '3/4',
                                component: {
                                    name: 'tag',
                                    customizationData: {
                                        repeatData: {
                                            '3d-customization-normal-repeat': repeatData
                                        }
                                    }
                                }
                            }
                        };
                        console.log("data3_8 data3_8 UPLOADIMAGE ****", _data3_);
                        var _customizationData = promizeThreeDObj.getComponentData(_data3_, 'customizationData');
                        promizeThreeDObj.updateComponent(_data3_);
                    }
                }
            });
        }, _this.pzPopupZoomSlider = function (e) {
            var value = parseInt(e.target.value) * 0.1;
            var zoomValue = 0;
            var zoomData = {};

            var sliderValue = e.target.value;
            var promizeTwoDObj = _this.state.promizeTwoDObj;

            _this.setState({ pzPopupZoomSliderDefault: sliderValue }, function () {

                if (value > 0 && previousValue2DzoomValue > value) {
                    zoomValue = previousValue2DzoomValue - value;
                    zoomData = {
                        zoomOut: {
                            point: { x: 450, y: 450 },
                            value: zoomValue
                        }
                    };
                } else if (value > 0 && previousValue2DzoomValue < value) {
                    zoomValue = value - previousValue2DzoomValue;
                    zoomData = {
                        zoomIn: {
                            point: { x: 450, y: 450 },
                            value: zoomValue
                        }
                    };
                } else {
                    zoomData = {
                        zoomIn: {
                            point: { x: 450, y: 450 },
                            value: 0
                        }
                    };
                }

                var updateViewData = {
                    transformView: _defineProperty({}, _this.state.pzPopupViewType, zoomData)
                };

                previousValue2DzoomValue = value;

                promizeTwoDObj.updateView(updateViewData);
            });
        }, _this.pzPopupPanSlider = function (e) {
            var value = parseInt(e.target.value) * 10;
            var panData = {};

            var sliderValue = e.target.value;
            var promizeTwoDObj = _this.state.promizeTwoDObj;

            _this.setState({ pzPopupPanSliderDefault: sliderValue }, function () {

                if (value > 0 && previousValue2DpanValue > value) {
                    var panValue = previousValue2DpanValue - value;
                    panData = {
                        panLeft: panValue
                    };
                } else if (value > 0 && previousValue2DpanValue < value) {
                    var _panValue6 = value - previousValue2DpanValue;
                    panData = {
                        panRight: _panValue6
                    };
                } else if (value < 0 && previousValue2DpanValue > value) {
                    var _panValue7 = previousValue2DpanValue < 0 ? Math.abs(Math.abs(previousValue2DpanValue) - Math.abs(value)) : previousValue2DpanValue - value;
                    panData = {
                        panLeft: _panValue7
                    };
                } else if (value < 0 && previousValue2DpanValue < value) {
                    var _panValue8 = Math.abs(Math.abs(value) - Math.abs(previousValue2DpanValue));
                    panData = {
                        panRight: _panValue8
                    };
                } else {
                    panData = {
                        panRight: 0
                    };
                }
                previousValue2DpanValue = value;

                var updateViewData = {
                    transformView: _defineProperty({}, _this.state.pzPopupViewType, panData)
                };
                promizeTwoDObj.updateView(updateViewData);
            });
        }, _this.pzCanvasObjectGetItemByFieldName = function (fieldName, fieldValue) {
            var objects = Object.values(_this.state.pzCanvasObject);
            var object = objects.find(function (obj) {
                return parseInt(obj[fieldName]) === parseInt(fieldValue);
            });
            return object;
        }, _this.pzPopupRemove2DImageFromCanvasByMaterialChange = function () {
            var pzPopupCanvasUploadImages = _this.state.pzPopupCanvasUploadImages;

            console.log("%c pzPopupRemove2DImageFromCanvas", 'background-color:green;color:white');
            //console.log("DELETE PARAMS ", partNames)

            var customData = {};
            var ImagePartData = {};
            var uploadImagePartData = {};
            var pzCanvasObject = _this.state.pzCanvasObject;

            Object.keys(pzPopupCanvasUploadImages).length > 0 && Object.keys(pzPopupCanvasUploadImages).map(function (canvasObjKey, idx) {
                var uploadedImageData = {};
                var ImagePartData = {};

                var uploadImgObj = pzPopupCanvasUploadImages[canvasObjKey];

                uploadedImageData['removeImage'] = [uploadImgObj.addImageKey];
                if (uploadImgObj.uploadType == 'repeat') {
                    ImagePartData[uploadImgObj.viewType] = {
                        upload: uploadedImageData,
                        repeatSettings: {
                            objectSpacing: 0
                        }
                    };
                    customData = {
                        repeatData: _defineProperty({}, '2d-customization-popup-repeat', ImagePartData)
                    };
                } else {
                    ImagePartData[uploadImgObj.viewType] = uploadedImageData;
                    customData = {
                        uploadData: _defineProperty({}, '2d-customization-popup-repeat', ImagePartData)
                    };
                }

                if (canvasObjKey in pzCanvasObject) {
                    delete pzCanvasObject[canvasObjKey];
                }

                var data3_8 = {
                    name: 'tag_component',
                    component: {
                        name: _this.state.pzBaseType ? _this.state.pzBaseType : '3/4',
                        component: {
                            name: 'tag',
                            customizationData: customData
                        }
                    }
                };
                _this.state.promizeThreeDObj.updateComponent(data3_8);

                console.log("customData ", customData);
                //this.state.promizeTwoDObj.updateComponent(customData);
            });

            _this.setState({ pzCanvasObject: pzCanvasObject });
        }, _this.pzPopupRemove2DImageFromCanvas = function (partNames) {
            var uploadType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "repeat";

            console.log("%c pzPopupRemove2DImageFromCanvas", 'background-color:green;color:white');
            console.log("DELETE PARAMS ", partNames);
            var customData = {};
            var ImagePartData = {};
            var pzCanvasObject = _this.state.pzCanvasObject;

            Object.keys(partNames).length > 0 && Object.keys(partNames).map(function (partName, idx) {
                var uploadedImageData = {};
                console.log("DELETE PARAMS partNames ");
                uploadedImageData['removeImage'] = [].concat(_toConsumableArray(partNames[partName]));
                if (uploadType == 'repeat') {
                    ImagePartData[partName] = {
                        upload: uploadedImageData,
                        repeatSettings: {
                            objectSpacing: 0
                        }
                    };
                    customData = {
                        repeatData: _defineProperty({}, '2d-customization-popup-repeat', ImagePartData)
                    };
                } else {
                    ImagePartData[partName] = uploadedImageData;
                    customData = {
                        uploadData: _defineProperty({}, '2d-customization-popup-repeat', ImagePartData)
                    };
                }

                if (Object.values(partNames[partName]).length > 0) {
                    Object.values(partNames[partName]).map(function (partNameIdx, indx) {

                        var canvasObjKey = 'FObject_option_background_' + partName + '_' + partNameIdx;
                        console.log("canvasObjKey   ", canvasObjKey);
                        if (canvasObjKey in pzCanvasObject) {
                            delete pzCanvasObject[canvasObjKey];
                        }
                    });
                }
            });
            console.log(customData);
            _this.state.promizeTwoDObj.updateComponent(customData);
            _this.setState({ pzCanvasObject: pzCanvasObject });
        }, _this.pzRemoveExistingImageFromCanvas = function (partNames, imageIdx) {
            var sourceOrigin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '3d-customization-popup-repeat';

            console.log("partNames ", partNames);
            var promizeThreeDObj = _this.props.promizeThreeDObj;
            var ImagePartData = {};
            Object.keys(partNames).length > 0 && Object.keys(partNames).map(function (partName, idx) {

                var uploadedImageData = {};
                uploadedImageData['removeImage'] = [];
                var removeKey = partNames[partName];

                //imageIdx = 'texture';
                // imageIdx = partNames[partName];
                /* if (imageIdx) {
                    removeKey += ('_' + imageIdx);
                } */
                uploadedImageData['removeImage'].push(removeKey);

                ImagePartData[partName] = {
                    repeatSettings: {
                        objectSpacing: 1
                    },
                    upload: uploadedImageData
                };

                if (Object.values(partNames).length == parseInt(idx) + 1) {
                    var data3_8 = {
                        name: 'tag_component',
                        component: {
                            name: _this.state.pzBaseType ? _this.state.pzBaseType : '3/4',
                            component: {
                                name: 'tag',
                                customizationData: {
                                    upload: [{}],
                                    repeatData: _defineProperty({}, sourceOrigin, ImagePartData)
                                }
                            }
                        }
                    };
                    _this.state.promizeThreeDObj.updateComponent(data3_8);
                }
            });
        }, _this.pzErrorDialogPopupHandler = function (key) {
            _this.setState({ pzErrorDialogPopup: false });
        }, _this.pzDialogPopupHandler = function (key) {
            var pzPrice = _this.state.pzBasePrice;

            if (key == 'cancel') {
                _this.setState({ pzDialogPopup: false });
            } else {
                var _this$state12 = _this.state,
                    pzCanvasObject = _this$state12.pzCanvasObject,
                    pzDefaultOptions = _this$state12.pzDefaultOptions,
                    pzApplyOptions = _this$state12.pzApplyOptions,
                    pzQuantity = _this$state12.pzQuantity;
                /*   (pzCanvasObject) && Object.keys(pzCanvasObject).length > 0 && Object.keys(pzCanvasObject).map((canvasview, index) => {
                      var canvasObject = pzCanvasObject[canvasview];
                      if (canvasObject && Object.keys(canvasObject).length > 0) {
                          Object.keys(canvasObject).map((obj, index) => {
                              if (obj != 'baseImage' && obj != 'pzOverlayImage') {
                                  delete canvasObject[obj];
                              }
                          });
                      }
                  }); */

                var componentData = {
                    name: 'breakaway',
                    component: {
                        name: _this.state.pzBaseType,
                        component: {
                            name: 'empty',
                            modelData: 'empty'
                        }
                    }
                };
                _this.state.promizeThreeDObj.updateComponent(componentData).then(function () {
                    _this.pzTurnModel('outside', true);
                });
                _this.state.promizeThreeDObj.cleanUp();

                pzDefaultOptions.length > 0 && pzDefaultOptions.map(function (def_opt, index) {
                    if (def_opt.promize_attribute_value.option_price) {
                        pzPrice = parseFloat(pzPrice) + parseFloat(def_opt.promize_attribute_value.option_price * pzQuantity);
                    }
                });
                _this.setState({
                    pzPopupAppliedData: {},
                    pzLoading: true,
                    pzDialogPopup: false,
                    pzErrorDialogPopup: false,
                    pzPopupUploadImages: { 'outside': {}, 'inside': {} },
                    pzPopupCanvasUploadImages: {},
                    pzPopupViewType: 'outside',
                    pzPopupViewBasedUploadType: { 'outside': 'repeat', 'inside': 'repeat' },
                    pzPopupRepeat: true,
                    pzPopupRepeatUploadImageKeys: [],
                    pzPopupCopyToBoth: false,
                    showCopyPopup: false,
                    pzPopupUploadImageProperties: {},
                    pzCanvasObject: {},
                    pzActiveOptions: {},
                    pzActiveImages: {},
                    pzActiveTexts: {},
                    pzProductPrice: pzPrice,
                    pzQuantity: 100,
                    pzApplyOptions: [],
                    pzDyesubTextDefaultColor: '#000000',
                    pzColorIconClicked: false
                }, function () {
                    //this.pzReloadCanvasObjects();
                });
            }
        }, _this.pzCheckSameMaterialType = function (materialType, objKey) {
            var pzActiveOptions = _this.state.pzActiveOptions;
            console.log("pzActiveOptionspzActiveOptions", pzActiveOptions);
            console.log("objekey", objKey);
            console.log("materialType ==> ", materialType);
            if (objKey && Object.keys(pzActiveOptions).length > 0 && objKey in pzActiveOptions) {

                console.log("condigiotjn true ");

                var currActionOptions = pzActiveOptions[objKey];
                console.log("currActionOptions ", currActionOptions);
                console.log("this.state.pzActiveOptions ", _this.state.pzActiveOptions);
                console.log("pzActiveOptions[objKey] ", pzActiveOptions[objKey]);
                var findIdx = pzActiveOptions[objKey].findIndex(function (element) {
                    console.log("ELEMENT ", element, "typeof element  ", typeof element === 'undefined' ? 'undefined' : _typeof(element));typeof element === "string" && element.indexOf(materialType) !== -1;
                });
                if (findIdx >= 0) {
                    console.log("TRUE ");
                    return true;
                } else {
                    console.log("false ");
                    return false;
                }
            } else {
                return false;
            }
        }, _this.pzGetPriceList = function (priceField) {
            //console.log("priceField ", priceField)
            var finalPrice = 0;
            if (priceField) {
                var priceList = [];
                var priceRange = priceField.split("&");
                if (priceRange) {
                    for (var i = 0; i < priceRange.length; i++) {
                        var currPrice = priceRange[i].split(':');
                        priceList[currPrice[0]] = currPrice[1];
                        if (i == 0) {
                            finalPrice = currPrice[1];
                        }
                    }
                }
                var priceListKeys = [].concat(_toConsumableArray(Object.keys(priceList)));
                //console.log("priceListKeys ", priceListKeys)

                for (var k = 0; k < priceListKeys.length; k++) {
                    if (_this.state.pzQuantity >= priceListKeys[k] && _this.state.pzQuantity < priceListKeys[k + 1] || k == priceListKeys.length - 1 && _this.state.pzQuantity >= priceListKeys[k]) {
                        //console.log(priceList[priceListKeys[k]]);
                        finalPrice = priceList[priceListKeys[k]];
                        break;
                    }
                }
            }
            //console.log("finalPrice ", finalPrice)
            return finalPrice;
        }, _this.pzDownloadImageByUrl = function (url) {
            return new Promise(function (resolve, reject) {
                var img = new Image();
                img.crossOrigin = 'anonymous';
                img.addEventListener('load', function (e) {
                    return resolve(img);
                });
                img.addEventListener('error', function () {
                    return reject(new Error('Failed to load image from URL: ' + url));
                });
                img.src = url;
            });
        }, _this.pzGetUploadImage = function (uploadedFile) {
            return new Promise(function (resolve, reject) {
                var fileReader = new FileReader();
                fileReader.onload = async function (event) {
                    var image = await _this.pzDownloadImageByUrl(event.target.result);
                    resolve(image);
                };
                fileReader.onerror = function (event) {
                    reject(function () {
                        console.error('Error on reading the file: ' + error);
                    });
                };
                fileReader.readAsDataURL(uploadedFile);
            });
        }, _this.sortKeys = function (obj, sortedBy) {
            var sortable = [];
            for (var key in obj) {
                var t1 = sortedBy[0];
                var t2 = sortedBy[1];
                sortable.push([key, obj[key], obj[key][t1][t2]]);
            }
            sortable.sort(function (a, b) {
                return a[2] - b[2];
            });
            return sortable;
        }, _this.sortObjects = function (objects, sortBy) {
            var newObject = {};
            var sortedArray = _this.sortKeys(objects, sortBy);
            for (var i = 0; i < sortedArray.length; i++) {
                var key = sortedArray[i][0];
                var value = sortedArray[i][1];
                newObject[key] = value;
            }
            return newObject;
        }, _this.pzTurnModel = function (partName) {
            var resetZoomValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            //console.log("parname " + partName + resetZoomValue)
            var promizeThreeDObj = _this.state.promizeThreeDObj;
            var viewData = {
                view: {
                    toPosition: {
                        rotateTo: partName == 'outside' ? { x: 119, y: -4, z: 3 } : { x: -119, y: 1, z: 7 },
                        positionTo: { x: 0, y: 0, z: 0 },
                        resetZoom: resetZoomValue
                    }
                }
            };
            promizeThreeDObj.updateView(viewData);
        }, _this.pzHoverHandler = function (optionText, event) {

            var pzBoundRect = event.target.getBoundingClientRect();
            var OptionHover = {
                'text': optionText,
                'top': pzBoundRect.top + pzBoundRect.height, //event.clientY - event.target.offsetTop,
                'left': pzBoundRect.left + pzBoundRect.width / 2 //event.clientX - event.target.offsetLeft,
            };
            _this.setState({ pzActiveOptionHover: OptionHover });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PromizeHome, [{
        key: 'pzSendIncrementValueByType',
        value: function pzSendIncrementValueByType() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "text";
            var inc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (type == "text") {
                if (inc) {
                    return PromizeHome.pzTextIncrement++;
                } else {
                    return PromizeHome.pzTextIncrement;
                }
            } else {
                if (inc) {
                    return PromizeHome.pzUploadImageIncrement++;
                } else {
                    return PromizeHome.pzUploadImageIncrement;
                }
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            var _state = this.state,
                pzCustomizer = _state.pzCustomizer,
                pzActiveSection = _state.pzActiveSection,
                pzActiveTab = _state.pzActiveTab,
                pzActiveOptions = _state.pzActiveOptions,
                pzActiveImages = _state.pzActiveImages,
                pzRules = _state.pzRules,
                pzEditId = _state.pzEditId,
                pzIconsPath = _state.pzIconsPath;
            /* const rootElements = {
                threeParentElement: document.getElementById('three-container'),
                fabricParentElement: document.getElementById('fabric-container'),
                pdfParentElement: null,
                svgParentElement: null,
            }
                  var promizeThreeD = new PromizeThreeD(rootElements); */

            var pzUploadCanvasPopupContent = this.getPoupContent();

            var rootElements = {
                threeParentElement: document.getElementById('three-container'),
                fabricParentElement: document.getElementById('fabric-container'),
                zoomIn: document.getElementById('pz-zoom-in'),
                zoomOut: document.getElementById('pz-zoom-out'),
                autoRotate: document.getElementById('pz-auto-rotate'),
                panUp: document.getElementById('pan-up'),
                panDown: document.getElementById('pan-down')
            };

            var sceneData = {
                orbitControlsSettings: {
                    enableDamping: true,
                    dampingFactor: 0.05,
                    autoRotate: true,
                    minDistance: 10,
                    maxDistance: 105,
                    enableRotate: true,
                    enableZoom: true,
                    rotateSpeed: 2,
                    autoRotateSpeed: -2,
                    minPanLimit: -60,
                    maxPanLimit: 60,
                    panSpeed: 1
                },
                cameraPosition: {
                    x: 105,
                    y: 0,
                    z: 0
                },
                lightingData: {
                    "ambientLight": {
                        "type": "AmbientLight",
                        "position": [0, 0, 0],
                        "color": "#bbbbbb",
                        "intensity": 1
                    },
                    "diretionLight": {
                        "type": "DirectionalLight",
                        "position": [7, -1, -1],
                        "color": "#ffffff",
                        "intensity": 0.22
                    },
                    "diretionLight_1": {
                        "type": "DirectionalLight",
                        "position": [-8.5, -1.9, 7.5],
                        "color": "#ffffff",
                        "intensity": 0.25
                    }
                },
                hdriUrl: pzIconsPath + 'hdiurl_studio003small.jpg'
                /*shadow: {
                    modelUrl: pzIconsPath + 'images/lanyard/shadow/open/shadow.glb',
                    scale: {
                        x: 170,
                        y: 170,
                        z: 170
                    }
                }*/

                /* create 3d view */
            };var promize3D = {};

            var init = async function init() {
                promize3D = await new PromizeThreeD(sceneData, rootElements);
                _this2.setState({ promizeThreeDObj: promize3D, pzUploadCanvasPopupContent: pzUploadCanvasPopupContent, pzPageLoader: true }, function () {
                    _this2.state.promizeThreeDObj.on('pz:3d:updating', function (e) {
                        //console.log('pz updating');
                        _this2.setState({ pzPageLoader: true });
                    });
                    _this2.state.promizeThreeDObj.on('pz:3d:updated', function (e) {
                        //console.log('pz updating');
                        _this2.setState({ pzPageLoader: false });
                    });
                });
            };
            init();

            //fetch(this.state.pzApiUrl + 'getProductDetailWithAttributes/?id=' + this.state.pzECommerceProductId)

            fetch(this.state.pzApiUrl + 'getProductDetailWithAttributes', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                body: JSON.stringify({ store_hash: this.state.pzStoreHash, product_id: parseInt(this.state.pzECommerceProductId) })
            }).then(function (res) {
                return res.json();
            }).then(function (response) {
                pzCustomizer.product = response.product.promize_customizer;
                var pzSections = pzCustomizer.product.promize_sections;
                pzCustomizer.sections = {};
                pzCustomizer.tabs = {};
                pzSections.length > 0 && pzSections.map(function (section, sect_index) {
                    pzActiveSection = section.sort_id == 1 ? section.promize_section_id : pzActiveSection;
                    pzCustomizer.sections[section.promize_section_id] = section;
                    var promizeTabs = section.promize_tabs;
                    promizeTabs.length > 0 && promizeTabs.map(function (tab, tab_idex) {
                        if (tab.is_default_tab || tab_idex == 0) {
                            pzActiveTab[section.promize_section_id] = tab.promize_tab_id;
                        }
                        pzCustomizer.tabs[tab.promize_tab_id] = tab;
                        pzCustomizer.attributes = {};
                        pzCustomizer.attributeOptions = {};
                        pzCustomizer.attributeTexts = {};
                        pzCustomizer.attributeImages = {};
                        pzCustomizer.attributeCliparts = {};
                        pzCustomizer.subtabs = {};
                        pzCustomizer.attributeDomainTexts = {};
                    });
                    if (pzSections.length == sect_index + 1) {
                        _this2.setState({ "pzCustomizer": pzCustomizer, "pzActiveSection": pzActiveSection }, function () {
                            /* var canvasside = new fabric.Canvas('pz_preview_image', { preserveObjectStacking: true, });
                            this.setState({ pzCanvas: canvasside }, () => {
                                this.pzSetBaseImage();
                                pzInitializeFCanvas(this)
                            }); */

                        });
                    }
                });
                // Get 3d models 
                fetch(_this2.state.pzApiUrl + 'get3DModelCategories/?id=' + pzCustomizer.product.domain_id).then(function (res) {
                    return res.json();
                }).then(function (response) {
                    if (response.status == 200) {
                        var pzDesktopModels = {};
                        Object.keys(response['3D_models']).map(function (key, index) {
                            Object.keys(response['3D_models'][key].promize_domain_3d_model_images).map(function (val) {
                                pzDesktopModels[response['3D_models'][key].promize_domain_3d_model_images[val].promize_domain_3d_model_images_id] = response['3D_models'][key].promize_domain_3d_model_images[val];
                            });
                        });
                        // TODO Need to add mobile models
                        _this2.setState({ pzDesktopModels: pzDesktopModels, pzPageLoader: false });
                    }
                }).catch(function (err) {
                    console.log("Sorrry! There is a problem while fetching the models");
                });
                //Get General Settings
                fetch(_this2.state.pzApiUrl + 'getDomainSettings/?domain_id=' + pzCustomizer.product.domain_id).then(function (res) {
                    return res.json();
                }).then(function (response) {
                    var generalSettings = response.domain_settings;
                    _this2.setState({ generalSettings: generalSettings });
                }).catch(function (err) {
                    // handle errors
                });

                //Get Rules getProductRules
                fetch(_this2.state.pzApiUrl + 'getProductRules/?id=' + pzCustomizer.product.promize_customizer_id).then(function (res) {
                    return res.json();
                }).then(function (response) {
                    pzRules = response.product_rules;
                    _this2.setState({ pzRules: pzRules });
                }).catch(function (err) {
                    // handle errors
                });
                if (pzEditId) {
                    fetch(_this2.state.pzApiUrl + 'getSaveForLater', {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({ id: pzEditId })
                    }).then(function (res) {
                        return res.json();
                    }).then(function (response) {
                        var options = response.records ? JSON.parse(response.records.selected_options) : {};
                        Object.keys(options).length > 0 && Object.keys(options).map(function (viewId, index) {
                            var selected = options[viewId];
                            Object.keys(selected).length > 0 && Object.keys(selected).map(function (selected_object, index) {
                                if (selected[selected_object].customType == 'option' && selected[selected_object].tabAttrId && selected[selected_object].tabAttrValueId) {
                                    pzActiveOptions[selected[selected_object].tabAttrId] = selected[selected_object].tabAttrValueId;
                                } else if (selected[selected_object].customType == 'uploadimage' && selected[selected_object].tabAttrValueId) {
                                    if (pzActiveImages[selected[selected_object].tabAttrValueId] == undefined) {
                                        pzActiveImages[selected[selected_object].tabAttrValueId] = [];
                                    }
                                    pzActiveImages[selected[selected_object].tabAttrValueId].push(selected[selected_object].src);
                                }
                            });
                        });
                        _this2.setState({ pzCanvasObject: options, pzActiveOptions: pzActiveOptions, pzActiveImages: pzActiveImages }, function () {
                            _this2.pzReloadCanvasObjects();
                        });
                    });
                } else {
                    //fetch(this.state.pzApiUrl + 'getDefaultOptions/?id=' + this.state.pzECommerceProductId)
                    fetch(_this2.state.pzApiUrl + 'getDefaultOptions', {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({ store_hash: _this2.state.pzStoreHash, product_id: parseInt(_this2.state.pzECommerceProductId) })
                    }).then(function (res) {
                        return res.json();
                    }).then(function (response) {
                        var pzDefaultOptions = response.defaultOptions;

                        _this2.setState({ pzDefaultOptions: pzDefaultOptions, "pzLoading": true, pzPageLoader: false }, function () {});
                    });
                }
            }).catch(function (err) {
                // handle errors
            });
        }
    }, {
        key: 'pzCapitalizeFirstLetter',

        /**
         * Convert the first character to uppercase
         * @param str 
         * 
         * @returns the string Convert the first character to uppercase
         */
        value: function pzCapitalizeFirstLetter(str) {
            if (str && typeof str === 'string') {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        }

        /**
         * Save the designed canvas image to server 
         * 
         * return the filepath
         */

        /** OPENS A POPUP  */


        /**
         * Upload the image from popup
         */

        //pzPopupRemoveImage = (e, viewType, objKey) => {


        /***
         * Send the repeat properties when upload button is clicked.
         */

        /**
         * Single upload Image
         */


        /**
         * Uncheck the repeat checkbox
         */

        /**
         * Popup - Apply to both sides
         */


        /**
         * Popup - Switch from front to back and viceversa
         */


        /**
         * Delete the image based on uploadType
         * 
         * params - uploadType = repeat or normal
         * params - partNames is an object. 
         * partNames['outside'] = ['outside_1', 'outside_2']
         */

    }, {
        key: 'render',
        value: function render() {
            return React.createElement(
                React.Fragment,
                null,
                this.state.promizeThreeDObj && this.state.pzLoading && Object.keys(this.state.pzCustomizer).length > 0 ? React.createElement(PZHome, _extends({ HomeComponent: this }, this.state)) : ''
            );
        }
    }]);

    return PromizeHome;
}(React.Component);

PromizeHome.popupUploadImageCount = 0;
PromizeHome.pzTextIncrement = 0;
PromizeHome.pzUploadImageIncrement = 0;


ReactDOM.render(React.createElement(PromizeHome, null), document.getElementById('root'));
